webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "editreqmodal",
    attrs: {
      "id": "edit-requirement-modal",
      "name": "edit-requirement-modal",
      "title": "Edit requirement",
      "size": "lg",
      "busy": _vm.submitting,
      "ok-title": "Update",
      "ok-disabled": !_vm.name || _vm.loading,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "update-requirement-form"
    }
  }, [_c('b-form-group', {
    attrs: {
      "feedback": _vm.nameInvalidFeedback,
      "state": _vm.nameState
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Requirement name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "Set a custom ID for this Requirement"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Requirement ID (optional)"
    },
    model: {
      value: (_vm.displayID),
      callback: function($$v) {
        _vm.displayID = $$v
      },
      expression: "displayID"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "These types can be managed on the rmCloud Configuration screen",
      "feedback": _vm.requirementTypeInvalidFeedback,
      "state": _vm.requirementTypeState
    }
  }, [_c('span', {
    attrs: {
      "id": "requirement-type-select"
    }
  }, [_c('multiselect', {
    attrs: {
      "disabled": _vm.selectedRequirements.length > 0,
      "options": _vm.requirementTypes,
      "loading": _vm.requirementTypesLoading,
      "allow-empty": false,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Select a requirement type",
      "label": "name",
      "track-by": "requirement_type_id"
    },
    model: {
      value: (_vm.selectedRequirementType),
      callback: function($$v) {
        _vm.selectedRequirementType = $$v
      },
      expression: "selectedRequirementType"
    }
  })], 1), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "requirement-type-select",
      "triggers": "hover",
      "content": "To edit the requirement type, remove any linked requirements below.",
      "disabled": _vm.selectedRequirements.length === 0
    }
  })], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Description",
      "rows": 2,
      "max-rows": 6
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.statuses,
      "loading": _vm.statusesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Status",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.availableRequirements,
      "multiple": true,
      "loading": _vm.requirementsLoading,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": _vm.getRequirementsPlaceholder(),
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "issues-multiselect-group-edit"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.sortedIssues,
      "multiple": true,
      "loading": _vm.issuesLoading,
      "custom-label": _vm.customIssueLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "disabled": _vm.shouldDisableIssuesMultiselect,
      "placeholder": "Select issue(s)",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedIssues),
      callback: function($$v) {
        _vm.selectedIssues = $$v
      },
      expression: "selectedIssues"
    }
  })], 1), _vm._v(" "), (_vm.shouldDisableIssuesMultiselect) ? _c('b-tooltip', {
    attrs: {
      "target": "issues-multiselect-group-edit",
      "triggers": "hover"
    }
  }, [_vm._v("\n      No issues found on this Jira project!\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.contents,
      "loading": _vm.contentsLoading,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "max": 20,
      "placeholder": "Select Confluence content",
      "label": "title",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedContents),
      callback: function($$v) {
        _vm.selectedContents = $$v
      },
      expression: "selectedContents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.components,
      "multiple": true,
      "loading": _vm.componentsLoading,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Component(s)",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedComponents),
      callback: function($$v) {
        _vm.selectedComponents = $$v
      },
      expression: "selectedComponents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.assignees,
      "loading": _vm.assigneesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Assign to",
      "label": "displayName",
      "track-by": "key"
    },
    model: {
      value: (_vm.selectedAssignee),
      callback: function($$v) {
        _vm.selectedAssignee = $$v
      },
      expression: "selectedAssignee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('b-form-group', {
      key: attribute.attribute_id
    }, [(attribute.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(attribute.name))]), _vm._v(" "), _c('b-form-select', {
      attrs: {
        "options": _vm.getOptionsArray(attribute.options)
      },
      model: {
        value: (_vm.requirement.attributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.requirement.attributes, attribute.attribute_id, $$v)
        },
        expression: "requirement.attributes[attribute.attribute_id]"
      }
    })], 1) : _c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": attribute.name
      },
      model: {
        value: (_vm.requirement.attributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.requirement.attributes, attribute.attribute_id, $$v)
        },
        expression: "requirement.attributes[attribute.attribute_id]"
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.submitting) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Updating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "create-baseline-button"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-baseline-modal",
      modifiers: {
        "create-baseline-modal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n      Create baseline\n    ")])], 1), _vm._v(" "), _c('create-baseline-modal'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-3"
  }, [_c('baseline-list', {
    attrs: {
      "baselines": _vm.baselines
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.currentBaseline) ? _c('baseline-detail', {
    attrs: {
      "baseline-prop": _vm.currentBaseline
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "rm-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedRequirements), function(requirement) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(requirement.description))])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])
}]}

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('footer', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "href": "https://purpledrapes.atlassian.net/servicedesk/customer/portal/2",
      "target": "_blank"
    }
  }, [_c('icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": "question-circle"
    }
  }), _vm._v(" Get help\n    ")], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.requirement) ? _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.requirement.name))])]), _vm._v(" "), _c('edit-requirement-modal', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._v(" "), _c('move-requirement-modal', {
    attrs: {
      "requirements": [_vm.requirement],
      "modalId": "move-requirement-modal-RequirementsDetail"
    }
  }), _vm._v(" "), _c('delete-requirement-modal', {
    attrs: {
      "requirements": [_vm.requirement],
      "modalId": "delete-requirement-modal-RequirementsDetail"
    }
  }), _vm._v(" "), _c('preview-image-modal', {
    attrs: {
      "modalImageUrl": _vm.modalImageUrl,
      "modalImageFilename": _vm.modalImageFilename
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.edit-requirement-modal",
      modifiers: {
        "edit-requirement-modal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n        Edit\n      ")], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-requirement-modal-RequirementsDetail",
      modifiers: {
        "move-requirement-modal-RequirementsDetail": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n        Move\n      ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-requirement-modal-RequirementsDetail",
      modifiers: {
        "delete-requirement-modal-RequirementsDetail": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n        Delete\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.requirement.requirement_type.prefix) + _vm._s(_vm.requirement.display_id ? _vm.requirement.display_id : _vm.requirement.requirement_id))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Type:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.requirement.requirement_type.name) + " Requirement")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(_vm.requirement.created_at + 'Z')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Reporter:")]), _vm._v(" "), (_vm.reporter) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.reporter.displayName) + "\n              ")]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Assignee:")]), _vm._v(" "), (_vm.assignee) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.assignee.displayName) + "\n              ")]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), (_vm.status) ? _c('td', [_c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.status.name) + " ")])], 1) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Component(s):")]), _vm._v(" "), (_vm.selectedComponents.length > 0) ? _c('td', [_vm._l((_vm.selectedComponents), function(component) {
    return [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "secondary"
      }
    }, [_vm._v(_vm._s(component) + " ")]), _vm._v(" "), _vm._t("default")]
  })], 2) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(attribute.name) + ":")]), _vm._v(" "), (_vm.requirement.attributes[attribute.attribute_id]) ? _c('td', [_vm._v("\n                " + _vm._s(_vm.getCustomAttributeValue(attribute, _vm.requirement.attributes)) + "\n              ")]) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.requirement.description) ? _c('b-form-textarea', {
    attrs: {
      "plaintext": "",
      "max-rows": 6,
      "value": _vm.requirement.description
    }
  }) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to add a description")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked requirements")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedRequirements.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedRequirements), function(requirement) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.goToReq(requirement.requirement_id)
        }
      }
    }, [_vm._v(_vm._s(requirement.requirement_type.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link requirements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked Issues")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedIssues.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedIssues), function(issue) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (issue.key))
      }
    }, [_vm._v(_vm._s(issue.key))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(issue.fields.summary))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": issue.fields.issuetype.iconUrl
      }
    })])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link issues")])])])]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Linked Confluence Content")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.selectedContents.length > 0) ? _c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedContents), function(content) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": ((_vm.$auth.user().atlassian_base_url) + "/wiki" + (content._links.webui))
      }
    }, [_vm._v(_vm._s(content.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(content.history.lastUpdated.friendlyWhen))]), _vm._v(" "), _c('td', _vm._l((content.history.contributors.publishers.users.map(function (a) { return a.displayName; })), function(displayName, index) {
      return _c('span', [_c('span', [_vm._v(_vm._s(displayName))]), (index + 1 < content.history.contributors.publishers.users.map(function (a) { return a.displayName; }).length) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }))])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("Click \"Edit\" above to link Confluence content")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Attachments")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_c('tbody', _vm._l((_vm.requirement.attachments), function(attachment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(attachment.original_file_name))]), _vm._v(" "), _c('td', [(_vm.isImageFilename(attachment.original_file_name)) ? _c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Preview"
      },
      on: {
        "click": function($event) {
          _vm.previewFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "search-plus"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Download"
      },
      on: {
        "click": function($event) {
          _vm.downloadFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "download"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "button-need-pointer",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(attachment)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash-o"
      }
    })], 1)])])
  }))]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "file_input"
    },
    on: {
      "change": function($event) {
        _vm.processFile($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Activity")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm requirement-detail-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.revisions), function(revision, index) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(revision.created_at)))]), _vm._v(" "), (_vm.userLookup[revision.account_id]) ? _c('td', [_vm._v(_vm._s(_vm.userLookup[revision.account_id].displayName))]) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(revision.action))]), _vm._v(" "), (revision.changed_fields) ? _c('td', [_vm._l((revision.changed_fields.split(',')), function(changedField) {
      return [_c('b-badge', {
        attrs: {
          "pill": "",
          "variant": "info"
        }
      }, [_vm._v(_vm._s(changedField) + " ")]), _vm._v(" "), _vm._t("default")]
    })], 2) : _c('td', {
      staticClass: "help-text"
    }, [_vm._v("None")])])
  }))])])])])], 1) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Last Updated")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Contributors")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Revision")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Changed Fields")])])])
}]}

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-base"
    }
  }, [_c('app-nav'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "rm-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedRequirements), function(requirement) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(requirement.description))])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])
}]}

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "max": 20,
      "placeholder": "Link requirements to content",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "moverequirementmodal",
    attrs: {
      "id": _vm.modalId,
      "name": "move-requirement-modal",
      "title": _vm.requirements.length > 1 ? ("Move " + (_vm.requirements.length) + " requirements") : 'Move requirement',
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Move",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.selectedFolder
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }), _vm._v(" "), (_vm.selectedFolder && _vm.requirements.length === 1) ? _c('span', [_vm._v("This requirement will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : (_vm.selectedFolder && _vm.requirements.length > 1) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.requirements.length))]), _vm._v(" requirements will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Moving\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mt-4"
  }, [_vm._v("Custom Fields")]), _vm._v(" "), (!_vm.projectsLoading) ? _c('div', [(_vm.attributes.length > 0) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Field name")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Project name")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeAttributes), function(attribute) {
    return _c('b-row', {
      key: attribute.attribute_id,
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(attribute.name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.projectLookup[attribute.atlassian_project_id].name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.deleteAttribute(attribute.attribute_id)
        }
      }
    }, [_vm._v("Delete field")])], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(!_vm.showNewAttributeForm) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.enableNewAttributeForm
    }
  }, [_vm._v("New field")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showNewAttributeForm) ? _c('div', {
    staticClass: "form-group mt-2 mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "attribute-name",
      "placeholder": "Attribute name"
    },
    model: {
      value: (_vm.newAttributeName),
      callback: function($$v) {
        _vm.newAttributeName = $$v
      },
      expression: "newAttributeName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "Select project",
      "options": _vm.projectsArray
    },
    model: {
      value: (_vm.newAttributeProject),
      callback: function($$v) {
        _vm.newAttributeProject = $$v
      },
      expression: "newAttributeProject"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.typeOptions
    },
    model: {
      value: (_vm.newAttributeType),
      callback: function($$v) {
        _vm.newAttributeType = $$v
      },
      expression: "newAttributeType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.shouldDisableSubmitButton
    },
    on: {
      "click": _vm.createAttribute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.disableNewAttributeForm
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (_vm.newAttributeType === 'select') ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Add up to 10 options",
      "aria-describedby": "input-live-feedback",
      "state": _vm.nameState
    },
    model: {
      value: (_vm.attributeOptionToAdd),
      callback: function($$v) {
        _vm.attributeOptionToAdd = $$v
      },
      expression: "attributeOptionToAdd"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-live-feedback"
    }
  }, [_vm._v("\n              Enter no more than 75 characters\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.shouldDisableAddButton,
      "variant": "info"
    },
    on: {
      "click": _vm.addAttributeOption
    }
  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, _vm._l((_vm.newAttributeOptions), function(opt) {
    return _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(opt))])
  }))], 1) : _vm._e()], 1) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mt-4"
  }, [_vm._v("Requirement Types")]), _vm._v(" "), (_vm.requirementTypes.length > 0) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Prefix")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('strong', [_vm._v("Level")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.requirementTypes), function(requirementType) {
    return _c('div', [(_vm.currentlyEditingARequirementType && _vm.requirementTypeIdBeingEdited === requirementType.requirement_type_id) ? _c('b-row', {
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "id": "requirement-type-name",
        "placeholder": "Requirement type name"
      },
      model: {
        value: (_vm.updateRequirementTypeName),
        callback: function($$v) {
          _vm.updateRequirementTypeName = $$v
        },
        expression: "updateRequirementTypeName"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "id": "requirement-type-prefix",
        "placeholder": "Requirement type prefix"
      },
      model: {
        value: (_vm.updateRequirementTypePrefix),
        callback: function($$v) {
          _vm.updateRequirementTypePrefix = $$v
        },
        expression: "updateRequirementTypePrefix"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "id": "requirement-type-level",
        "placeholder": "Requirement type level"
      },
      model: {
        value: (_vm.updateRequirementTypeLevel),
        callback: function($$v) {
          _vm.updateRequirementTypeLevel = $$v
        },
        expression: "updateRequirementTypeLevel"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button-group', [_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm",
        "disabled": !_vm.updateRequirementTypeName || !_vm.updateRequirementTypePrefix
      },
      on: {
        "click": function($event) {
          _vm.updateRequirementType(requirementType.requirement_type_id)
        }
      }
    }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": _vm.disableUpdateRequirementTypeForm
      }
    }, [_vm._v("Cancel")])], 1)], 1)], 1) : _c('b-row', {
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.prefix) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_vm._v("\n        " + _vm._s(requirementType.level) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "warning",
        "size": "sm",
        "disabled": _vm.currentlyEditingARequirementType || _vm.showNewRequirementTypeForm
      },
      on: {
        "click": function($event) {
          _vm.enableUpdateRequirementTypeForm(requirementType)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm",
        "disabled": _vm.currentlyEditingARequirementType || _vm.showNewRequirementTypeForm
      },
      on: {
        "click": function($event) {
          _vm.deleteRequirementType(requirementType.requirement_type_id)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(!_vm.showNewRequirementTypeForm) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.currentlyEditingARequirementType
    },
    on: {
      "click": _vm.enableNewRequirementTypeForm
    }
  }, [_vm._v("New requirement type")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showNewRequirementTypeForm) ? _c('div', {
    staticClass: "form-group mt-2 mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "requirement-type-name",
      "placeholder": "Requirement type name"
    },
    model: {
      value: (_vm.newRequirementTypeName),
      callback: function($$v) {
        _vm.newRequirementTypeName = $$v
      },
      expression: "newRequirementTypeName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "requirement-type-prefix",
      "placeholder": "Requirement type prefix"
    },
    model: {
      value: (_vm.newRequirementTypePrefix),
      callback: function($$v) {
        _vm.newRequirementTypePrefix = $$v
      },
      expression: "newRequirementTypePrefix"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.newRequirementTypeName || !_vm.newRequirementTypePrefix
    },
    on: {
      "click": _vm.createRequirementType
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.disableNewRequirementTypeForm
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authError) ? _c('div', {
    staticClass: "authenticate-error"
  }, [_c('p', [_vm._v("rmCloud couldn't sign you in.")]), _vm._v(" "), _c('p', {
    staticClass: "authenticate-error-detail"
  }, [_vm._v("Please reload the page. If this keeps happening, contact support and quote: " + _vm._s(_vm.authError))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.folder.name))])]), _vm._v(" "), _c('edit-folder-modal', {
    attrs: {
      "folderId": _vm.folderId
    }
  }), _vm._v(" "), _c('move-folder-modal', {
    attrs: {
      "folder": _vm.folder
    }
  }), _vm._v(" "), _c('delete-folder-modal', {
    attrs: {
      "folderId": _vm.folderId
    }
  }), _vm._v(" "), _c('create-requirement-modal', {
    attrs: {
      "parentFolderId": _vm.folderId,
      "modalId": "create-requirement-modal-FolderDetail"
    }
  }), _vm._v(" "), _c('create-folder-modal', {
    attrs: {
      "parentFolderId": _vm.folderId,
      "modalId": "create-folder-modal-FolderDetail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.edit-folder-modal",
      modifiers: {
        "edit-folder-modal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n      Edit\n    ")], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-folder-modal",
      modifiers: {
        "move-folder-modal": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n      Move\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-folder-modal",
      modifiers: {
        "delete-folder-modal": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n      Delete\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-requirement-modal-FolderDetail",
      modifiers: {
        "create-requirement-modal-FolderDetail": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_vm._v("\n      Create a requirement in this folder\n    ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-folder-modal-FolderDetail",
      modifiers: {
        "create-folder-modal-FolderDetail": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_vm._v("\n      Create a child folder\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "movefoldermodal",
    attrs: {
      "id": "move-folder-modal",
      "name": "move-folder-modal",
      "title": "Move folder",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Move",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.selectedFolder
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('folders-list', {
    attrs: {
      "folders": _vm.folders,
      "currentFolder": _vm.folder
    }
  }), _vm._v(" "), (_vm.selectedFolder) ? _c('span', [_vm._v("This folder will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Moving\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('b-form', {
    attrs: {
      "inline": ""
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Baseline 1:",
      "description": "Select the first baseline you'd like to compare",
      "label-for": "baseline-1"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "baseline-1",
      "options": _vm.baselinesArray,
      "required": ""
    },
    model: {
      value: (_vm.selectedBaselinesLite.baselineOne),
      callback: function($$v) {
        _vm.selectedBaselinesLite.baselineOne = $$v
      },
      expression: "selectedBaselinesLite.baselineOne"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Baseline 2:",
      "description": "Select the second baseline you'd like to compare",
      "label-for": "baseline-2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "baseline-2",
      "options": _vm.baselinesArray,
      "required": ""
    },
    model: {
      value: (_vm.selectedBaselinesLite.baselineTwo),
      callback: function($$v) {
        _vm.selectedBaselinesLite.baselineTwo = $$v
      },
      expression: "selectedBaselinesLite.baselineTwo"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": !_vm.selectedBaselinesLite.baselineOne || !_vm.selectedBaselinesLite.baselineTwo || _vm.loading
    }
  }, [(_vm.loading) ? _c('span', [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Comparing")], 1) : _c('span', [_vm._v("Compare")])])], 1)], 1), _vm._v(" "), (_vm.hasResults && _vm.requirementTypeLookupReady) ? _c('table', {
    staticClass: "rm-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((Array.from(_vm.diffLookup)), function(requirement) {
    return _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.goToReq(requirement[0])
        }
      }
    }, [_vm._v(_vm._s(_vm.getDisplayID(requirement[0])))])]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    })]), _vm._v(" "), (requirement[1].has('name')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Name\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('name').baselineOne) ? _c('span', [_vm._v(_vm._s(requirement[1].get('name').baselineOne))]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('name').baselineTwo) ? _c('span', [_vm._v(_vm._s(requirement[1].get('name').baselineTwo))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('requirement_type_id')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Type\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('requirement_type_id').baselineOne) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.requirementTypeLookup[requirement[1].get('requirement_type_id').baselineOne].name) + " requirement\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('requirement_type_id').baselineTwo) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.requirementTypeLookup[requirement[1].get('requirement_type_id').baselineTwo].name) + " requirement\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('assigned_to')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Assignee\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('assigned_to').baselineOne && _vm.userLookup[requirement[1].get('assigned_to').baselineOne.account_id]) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.userLookup[requirement[1].get('assigned_to').baselineOne.account_id].displayName) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('assigned_to').baselineTwo && _vm.userLookup[requirement[1].get('assigned_to').baselineTwo.account_id]) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.userLookup[requirement[1].get('assigned_to').baselineTwo.account_id].displayName) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('status')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Status\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('status').baselineOne) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.statusMap.get(requirement[1].get('status').baselineOne.atlassian_status_id.toString()).name) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('status').baselineTwo) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.statusMap.get(requirement[1].get('status').baselineTwo.atlassian_status_id.toString()).name) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('components')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Components\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('components').baselineOne) ? _c('div', _vm._l((requirement[1].get('components').baselineOne), function(component) {
      return _c('span', [_vm._v("\n          " + _vm._s(_vm.componentMap.get(component.atlassian_component_id.toString()).name) + "\n          ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('components').baselineTwo) ? _c('div', _vm._l((requirement[1].get('components').baselineTwo), function(component) {
      return _c('span', [_vm._v("\n          " + _vm._s(_vm.componentMap.get(component.atlassian_component_id.toString()).name) + "\n          ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('description')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Description\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('description').baselineOne) ? _c('b-form-textarea', {
      attrs: {
        "plaintext": "",
        "no-resize": "",
        "max-rows": 6,
        "value": requirement[1].get('description').baselineOne
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('description').baselineTwo) ? _c('b-form-textarea', {
      attrs: {
        "plaintext": "",
        "no-resize": "",
        "max-rows": 6,
        "value": requirement[1].get('description').baselineTwo
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (requirement[1].has('linked_requirements')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Requirements\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('linked_requirements').baselineOne) ? _c('span', _vm._l((requirement[1].get('linked_requirements').baselineOne), function(reqOne) {
      return _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.goToReq(reqOne.requirement_id)
          }
        }
      }, [_vm._v(_vm._s(reqOne.requirement_type.prefix) + _vm._s(reqOne.display_id ? reqOne.display_id : reqOne.requirement_id))]), _vm._v(" \n          ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('linked_requirements').baselineTwo) ? _c('span', _vm._l((requirement[1].get('linked_requirements').baselineTwo), function(reqTwo) {
      return _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.goToReq(reqTwo.requirement_id)
          }
        }
      }, [_vm._v(_vm._s(reqTwo.requirement_type.prefix) + _vm._s(reqTwo.display_id ? reqTwo.display_id : reqTwo.requirement_id))]), _vm._v(" \n          ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('issues') && Object.keys(_vm.issueLookup).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Issues\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('issues').baselineOne) ? _c('div', _vm._l((requirement[1].get('issues').baselineOne), function(issue) {
      return _c('span', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id.toString()].key))
        }
      }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id.toString()].key))]), _vm._v(" \n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('issues').baselineTwo) ? _c('div', _vm._l((requirement[1].get('issues').baselineTwo), function(issue) {
      return _c('span', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id.toString()].key))
        }
      }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id.toString()].key))]), _vm._v(" \n        ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('contents')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Confluence Content\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('contents').baselineOne) ? _c('div', _vm._l((requirement[1].get('contents').baselineOne), function(content) {
      return _c('span', [_vm._v("\n          " + _vm._s(content.atlassian_content_id) + "\n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('contents').baselineTwo) ? _c('div', _vm._l((requirement[1].get('contents').baselineTwo), function(content) {
      return _c('span', [_vm._v("\n          " + _vm._s(content.atlassian_content_id) + "\n        ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('attachments')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Attachments\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('attachments').baselineOne) ? _c('div', _vm._l((requirement[1].get('attachments').baselineOne), function(attachment) {
      return _c('span', [_vm._v("\n          " + _vm._s(attachment.original_file_name) + "\n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('attachments').baselineTwo) ? _c('div', _vm._l((requirement[1].get('attachments').baselineTwo), function(attachment) {
      return _c('span', [_vm._v("\n          " + _vm._s(attachment.original_file_name) + "\n        ")])
    })) : _vm._e()])]) : _vm._e()])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "id": "id"
    }
  }, [_vm._v("Requirement ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "name"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "baseline-one"
    }
  }, [_vm._v("Baseline 1")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "baseline-two"
    }
  }, [_vm._v("Baseline 2")])])])
}]}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "createreqmodal",
    attrs: {
      "id": _vm.modalId,
      "busy": _vm.submitting,
      "title": "Create a requirement",
      "name": "create-requirement-modal",
      "size": "lg",
      "ok-title": "Create",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.name || !_vm.selectedRequirementType || _vm.loading
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('form', {
    attrs: {
      "id": "create-requirement-form"
    }
  }, [_c('b-form-group', {
    attrs: {
      "feedback": _vm.nameInvalidFeedback,
      "state": _vm.nameState
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Requirement name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "Set a custom ID for this Requirement"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Requirement ID (optional)"
    },
    model: {
      value: (_vm.displayID),
      callback: function($$v) {
        _vm.displayID = $$v
      },
      expression: "displayID"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "These types can be managed on the rmCloud Configuration screen",
      "feedback": _vm.requirementTypeInvalidFeedback,
      "state": _vm.requirementTypeState
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirementTypes,
      "loading": _vm.requirementTypesLoading,
      "allow-empty": false,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Select a requirement type",
      "label": "name",
      "track-by": "requirement_type_id"
    },
    model: {
      value: (_vm.selectedRequirementType),
      callback: function($$v) {
        _vm.selectedRequirementType = $$v
      },
      expression: "selectedRequirementType"
    }
  })], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Description",
      "rows": 2,
      "max-rows": 6
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.statuses,
      "loading": _vm.statusesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Status",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.availableRequirements,
      "multiple": true,
      "loading": _vm.requirementsLoading,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": _vm.getRequirementsPlaceholder(),
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "issues-multiselect-group-create"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.sortedIssues,
      "multiple": true,
      "loading": _vm.issuesLoading,
      "custom-label": _vm.customIssueLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "disabled": _vm.shouldDisableIssuesMultiselect,
      "placeholder": "Select issue(s)",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedIssues),
      callback: function($$v) {
        _vm.selectedIssues = $$v
      },
      expression: "selectedIssues"
    }
  })], 1), _vm._v(" "), (_vm.shouldDisableIssuesMultiselect) ? _c('b-tooltip', {
    attrs: {
      "target": "issues-multiselect-group-create",
      "triggers": "hover"
    }
  }, [_vm._v("\n      No issues found on this Jira project!\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.contents,
      "loading": _vm.contentsLoading,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "max": 20,
      "placeholder": "Select Confluence content",
      "label": "title",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedContents),
      callback: function($$v) {
        _vm.selectedContents = $$v
      },
      expression: "selectedContents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.components,
      "multiple": true,
      "loading": _vm.componentsLoading,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Component(s)",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedComponents),
      callback: function($$v) {
        _vm.selectedComponents = $$v
      },
      expression: "selectedComponents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.assignees,
      "loading": _vm.assigneesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Assign to",
      "label": "displayName",
      "track-by": "key"
    },
    model: {
      value: (_vm.selectedAssignee),
      callback: function($$v) {
        _vm.selectedAssignee = $$v
      },
      expression: "selectedAssignee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('b-form-group', {
      key: attribute.attribute_id
    }, [(attribute.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(attribute.name))]), _vm._v(" "), _c('b-form-select', {
      attrs: {
        "options": _vm.getOptionsArray(attribute.options)
      },
      model: {
        value: (_vm.selectedAttributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.selectedAttributes, attribute.attribute_id, $$v)
        },
        expression: "selectedAttributes[attribute.attribute_id]"
      }
    })], 1) : _c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": attribute.name
      },
      model: {
        value: (_vm.selectedAttributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.selectedAttributes, attribute.attribute_id, $$v)
        },
        expression: "selectedAttributes[attribute.attribute_id]"
      }
    })], 1)
  }), _vm._v(" "), (_vm.currentProject) ? _c('span', [_vm._v("This will be added to project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])]) : _vm._e()], 2), _vm._v(" "), (_vm.submitting) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Creating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.currentProject) ? _c('div', {
    staticClass: "create-requirements-button"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-requirement-modal-RequirementsView",
      modifiers: {
        "create-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("New requirement")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-folder-modal-RequirementsView",
      modifiers: {
        "create-folder-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("New folder")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.import-issues-modal",
      modifiers: {
        "import-issues-modal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("Import requirements")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.export-requirements-modal",
      modifiers: {
        "export-requirements-modal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("Export requirements")])], 1) : _vm._e(), _vm._v(" "), _c('create-requirement-modal', {
    attrs: {
      "modalId": "create-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('create-folder-modal', {
    attrs: {
      "modalId": "create-folder-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('import-issues-modal', {
    attrs: {
      "currentProject": _vm.currentProject
    }
  }), _vm._v(" "), _c('export-requirements-modal'), _vm._v(" "), _c('move-requirement-modal', {
    attrs: {
      "requirements": _vm.selectedRequirements,
      "modalId": "move-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('delete-requirement-modal', {
    attrs: {
      "requirements": _vm.selectedRequirements,
      "modalId": "delete-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), (_vm.currentProject) ? _c('div', [(this.items.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-3 items-list-outer"
  }, [_c('div', {
    style: (_vm.selectedRequirements.length > 0 ? '' : 'visibility: hidden;')
  }, [_c('span', [_vm._v("Selected: ")]), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-requirement-modal-RequirementsView",
      modifiers: {
        "move-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n          Move\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-requirement-modal-RequirementsView",
      modifiers: {
        "delete-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n            Delete\n          ")])], 1), _vm._v(" "), _c('items-list', {
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.currentItem && _vm.currentItem.type.endsWith('requirement')) ? _c('requirements-detail', {
    attrs: {
      "id": Number.parseInt(_vm.currentItem.requirement_id)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentItem && _vm.currentItem.type === 'folder') ? _c('folder-detail', {
    attrs: {
      "folderId": Number.parseInt(_vm.currentItem.folder_id)
    }
  }) : _vm._e()], 1)]) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("Create your first requirement by clicking the \"New requirement\" button above")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folders-list",
    class: {
      inner: _vm.isInnerList
    }
  }, [(!_vm.isInnerList) ? _c('div', {
    staticClass: "individual-folder"
  }, [_c('icon', {
    staticClass: "text-primary",
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": "folder-o"
    }
  }), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isSelectedFolder(_vm.topLevel), disabled: _vm.isCurrentFolder(_vm.topLevel)
    },
    on: {
      "click": function($event) {
        _vm.setSelectedFolder(_vm.topLevel)
      }
    }
  }, [_vm._v("\n        (Top Level)\n      ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.folders), function(folder) {
    return _c('div', [_c('div', {
      staticClass: "individual-folder"
    }, [_c('icon', {
      staticClass: "text-primary",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": "folder-o"
      }
    }), _vm._v(" "), _c('a', {
      class: {
        active: _vm.isSelectedFolder(folder), disabled: _vm.isCurrentFolder(folder)
      },
      on: {
        "click": function($event) {
          _vm.setSelectedFolder(folder)
        }
      }
    }, [_vm._v("\n        " + _vm._s(folder.name) + "\n      ")]), _vm._v(" "), (folder.has_descendant_folders && !_vm.isCurrentFolder(folder)) ? _c('span', {
      staticClass: "expand-button",
      on: {
        "click": function($event) {
          _vm.toggle(folder)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": folder.open ? 'minus-square-o' : 'plus-square-o'
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), (folder.descendants) ? _c('folders-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (folder.open),
        expression: "folder.open"
      }],
      attrs: {
        "currentFolder": _vm.currentFolder,
        "folders": folder.descendants,
        "isInnerList": "true"
      }
    }) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchQuery && _vm.filteredRowsToIterate.length == 0) ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("No requirements found for your search query")])], 1) : (_vm.rows.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.headerRow), function(header) {
    return _c('th', [_vm._v(_vm._s(header))])
  }), _vm._v(" "), _vm._l((_vm.selectedIssueTypeColumns), function(issueType) {
    return _c('th', {
      attrs: {
        "id": issueType.name
      }
    }, [_vm._v(_vm._s(issueType.name))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredRowsToIterate), function(row) {
    return _c('tr', [_vm._l((row.requirements), function(requirement) {
      return _c('td', [(requirement.requirement_id != null) ? _c('div', [(requirement.atlassian_status_id != null && _vm.statusMap.has(requirement.atlassian_status_id.toString())) ? _c('span', {
        directives: [{
          name: "b-popover",
          rawName: "v-b-popover.hover",
          value: (_vm.statusMap.get(requirement.atlassian_status_id.toString()).name),
          expression: "statusMap.get(requirement.atlassian_status_id.toString()).name",
          modifiers: {
            "hover": true
          }
        }],
        class: _vm.getLozengeClassFromStatusCategory(_vm.statusMap.get(requirement.atlassian_status_id.toString()).statusCategory.key)
      }) : _vm._e(), _vm._v(" "), _c('a', {
        staticClass: "matrix-item-id",
        attrs: {
          "href": _vm.getNewTabLink(requirement.requirement_id),
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))]), _vm._v(" "), _c('div', {
        staticClass: "matrix-item-name"
      }, [_vm._v("\n            " + _vm._s(requirement.name) + "\n          ")])]) : _c('div', [_vm._v("-")])])
    }), _vm._v(" "), _vm._l((_vm.selectedIssueTypeColumns), function(issueType) {
      return _c('td', {
        attrs: {
          "headers": issueType.name
        }
      }, _vm._l((row.issues), function(issue) {
        return (_vm.issueLookup[issue.atlassian_issue_id] && _vm.issueLookup[issue.atlassian_issue_id].fields.issuetype.id === issueType.id) ? _c('div', [_c('span', {
          directives: [{
            name: "b-popover",
            rawName: "v-b-popover.hover",
            value: (_vm.issueLookup[issue.atlassian_issue_id].fields.status.name),
            expression: "issueLookup[issue.atlassian_issue_id].fields.status.name",
            modifiers: {
              "hover": true
            }
          }],
          class: _vm.getLozengeClassFromStatusCategory(_vm.issueLookup[issue.atlassian_issue_id].fields.status.statusCategory.key)
        }), _vm._v(" "), _c('a', {
          staticClass: "matrix-item-id",
          attrs: {
            "target": "_blank",
            "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id].key))
          }
        }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id].key))]), _vm._v(" "), _c('div', {
          staticClass: "matrix-item-name"
        }, [_vm._v("\n            " + _vm._s(_vm.issueLookup[issue.atlassian_issue_id].fields.summary) + " \n          ")])]) : _vm._e()
      }))
    })], 2)
  }))]) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("Please create at least one requirement to view the traceability matrix")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(!_vm.loading) ? _c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Link requirements to issue",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  }) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "id": "getting-started"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "align-self": "center"
    }
  }, [_c('h3', [_vm._v("Thanks for installing rmCloud!")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        You'll now see a link to the app in the main navigation:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location.png",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        Or, in the newer navigation it will be in the top of the screen:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location-new.png",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        For instructions on how to use rmCloud, "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://purpledrapes.atlassian.net/wiki/spaces/RD/pages/86933579/Getting+started"
    }
  }, [_vm._v("check out the Getting started page")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        For a quick overview of using rmCloud, check out the video below:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/P94bDH38vhE",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        If you ever need help (feature requests, bugs, not sure how to do something),\n        just click the \"Get help\" button in the bottom right corner of the main app:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my-3"
  }, [_c('img', {
    attrs: {
      "src": "https://d4wcwl3bu5zft.cloudfront.net/get-help-button.png"
    }
  })])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.openLinkRequirementsDialog
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  }), _vm._v("\n      Edit\n    ")], 1), _vm._v(" "), (_vm.requirements.length > 0) ? _c('table', {
    staticClass: "rm-table right-panel-requirements-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.requirements), function(requirement) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": _vm.getNewTabLink(requirement),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(requirement.prefix) + _vm._s(requirement.display_id ? requirement.display_id : requirement.requirement_id))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement.name))])])
  }))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")])])
}]}

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Link requirements to content",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "deleterequirementmodal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.requirements.length > 1 ? ("Are you sure you want to delete " + (_vm.requirements.length) + " requirements?") : 'Are you sure you want to delete this requirement?',
      "name": "delete-requirement-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Delete",
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    }
  }, [_vm._v("\n  This action can not be undone\n  "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Deleting\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("rmCloud Configuration")]), _vm._v(" "), _c('requirement-types-view'), _vm._v(" "), _c('custom-attributes-view'), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('h4', [_vm._v("Link Confluence Content")]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('p', [_vm._v("You have successfully connected your confluence instance.")]) : _c('p', [_vm._v("If you'd like to link Confluence content to your requirements, please install "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("rmCloud Connector")]), _vm._v(" on your Confluence instance.")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h4', [_vm._v("Other settings")]), _vm._v(" "), _c('h5', [_vm._v("When a requirement is created or updated")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentOnAssociatedIssues),
      expression: "commentOnAssociatedIssues"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.commentOnAssociatedIssues) ? _vm._i(_vm.commentOnAssociatedIssues, null) > -1 : (_vm.commentOnAssociatedIssues)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.commentOnAssociatedIssues,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.commentOnAssociatedIssues = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.commentOnAssociatedIssues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.commentOnAssociatedIssues = $$c
        }
      }
    }
  }), _vm._v("\n          Add comment to associated Jira issues\n        ")])]), _vm._v(" "), _c('h5', [_vm._v("When a requirement is assigned")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendEmailNotificationToAssignee),
      expression: "sendEmailNotificationToAssignee"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendEmailNotificationToAssignee) ? _vm._i(_vm.sendEmailNotificationToAssignee, null) > -1 : (_vm.sendEmailNotificationToAssignee)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.sendEmailNotificationToAssignee,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendEmailNotificationToAssignee = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendEmailNotificationToAssignee = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendEmailNotificationToAssignee = $$c
        }
      }
    }
  }), _vm._v("\n          Send email notification to assignee\n        ")])]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('div', [_c('h5', [_vm._v("Confluence space(s) to show when linking to requirements")]), _vm._v(" "), _c('p', [_vm._v("Only pages from these spaces will show up when linking requirements to pages.")]), _vm._v(" "), _c('p', [_vm._v("Leave this blank if you want to show pages from all spaces.")]), _vm._v(" "), _c('p', [_vm._v("To get your space name, check the URL of one of your Confluence pages. It will be yoursite.atlassian.net/wiki/spaces/SPACENAME/...")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confluenceSpacesToFilter),
      expression: "confluenceSpacesToFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "SPACE1,SPACE2"
    },
    domProps: {
      "value": (_vm.confluenceSpacesToFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confluenceSpacesToFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "spacesHelpBlock"
    }
  }, [_vm._v("\n            The space names should be comma separated e.g. SPACE1,SPACE2,SPACE3\n          ")])])]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-container', {
    staticClass: "filter-requirements-input",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    attrs: {
      "align-h": "start"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "name": "query",
      "placeholder": "Filter requirements"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n          Hide/show columns\n          "), _c('icon', {
    staticClass: "when-opened",
    attrs: {
      "name": "chevron-up"
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "when-closed",
    attrs: {
      "name": "chevron-down"
    }
  })], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkboxes1",
      "name": "flavour1",
      "options": _vm.issueTypeColumnOptions
    },
    model: {
      value: (_vm.selectedIssueTypeColumns),
      callback: function($$v) {
        _vm.selectedIssueTypeColumns = $$v
      },
      expression: "selectedIssueTypeColumns"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-1"
    }
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": _vm.loading ? 'spinner' : 'download',
      "pulse": _vm.loading
    }
  }), _vm._v(" Export\n          ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.generateDocx()
      }
    }
  }, [_vm._v("Word (.docx)")])], 2)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('h7', [_vm._v("Generating your export...")]), _vm._v(" "), _c('b-progress', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.progressValue,
      "variant": "success",
      "animated": ""
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('traceability-matrix-grid', {
    attrs: {
      "searchQuery": _vm.searchQuery,
      "selectedIssueTypeColumns": _vm.selectedIssueTypeColumns
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "exportrequirementsmodal",
    attrs: {
      "id": "export-requirements-modal",
      "title": "Export all requirements",
      "name": "export-requirements-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Export",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.format
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "field-formatOptions"
    }
  }, [_vm._v("Format:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "mb-3",
    attrs: {
      "id": "field-formatOptions",
      "options": _vm.formatOptions,
      "data-vv-name": "format"
    },
    model: {
      value: (_vm.format),
      callback: function($$v) {
        _vm.format = $$v
      },
      expression: "format"
    }
  })], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Exporting\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "createbaselinemodal",
    attrs: {
      "id": "create-baseline-modal",
      "name": "create-baseline-modal",
      "title": "Create a baseline",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Create",
      "ok-disabled": !_vm.baselineName,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "cancel": _vm.handleCancel,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "create-baseline-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "id": "baseline-name",
      "placeholder": "Baseline name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.baselineName),
      callback: function($$v) {
        _vm.baselineName = $$v
      },
      expression: "baselineName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Description",
      "rows": 2,
      "max-rows": 6
    },
    model: {
      value: (_vm.baselineDescription),
      callback: function($$v) {
        _vm.baselineDescription = $$v
      },
      expression: "baselineDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "id": "radios2",
      "stacked": ""
    },
    model: {
      value: (_vm.selectRequirementsOption),
      callback: function($$v) {
        _vm.selectRequirementsOption = $$v
      },
      expression: "selectRequirementsOption"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": 'all'
    }
  }, [_vm._v("Baseline all requirements in this project")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": 'folder'
    }
  }, [_vm._v("Baseline all requirements in a folder")]), _vm._v(" "), (_vm.selectRequirementsOption === 'folder') ? _c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }) : _vm._e(), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": 'individual'
    }
  }, [_vm._v("Select individual requirements in this project to baseline")])], 1)], 1), _vm._v(" "), (_vm.selectRequirementsOption === 'individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Select requirement(s)",
      "label": "name",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._v("This will be added to project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Creating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "image-modal",
      "name": "image-modal",
      "title": _vm.modalImageFilename,
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('b-img', {
    attrs: {
      "fluid": "",
      "src": _vm.modalImageUrl
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "baseline-list"
  }, _vm._l((_vm.baselines), function(baseline) {
    return _c('div', [_c('a', {
      class: {
        active: _vm.isCurrentBaseline(baseline)
      },
      attrs: {
        "title": baseline.name
      },
      on: {
        "click": function($event) {
          _vm.pushTheState(baseline)
        }
      }
    }, [_vm._v(_vm._s(baseline.name))])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "importissuesmodal",
    attrs: {
      "id": "import-issues-modal",
      "title": "Import requirements from CSV",
      "name": "import-issues-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Import",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.uuidFileName || !_vm.requirementType
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel,
      "shown": _vm.shown
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-group', {
    attrs: {
      "description": "These types can be managed on the rmCloud Configuration screen"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirementTypes,
      "loading": _vm.requirementTypesLoading,
      "allow-empty": false,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Select a requirement type to import these requirements as",
      "label": "name",
      "track-by": "requirement_type_id"
    },
    model: {
      value: (_vm.requirementType),
      callback: function($$v) {
        _vm.requirementType = $$v
      },
      expression: "requirementType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specificLocation),
      expression: "specificLocation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.specificLocation) ? _vm._i(_vm.specificLocation, null) > -1 : (_vm.specificLocation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.specificLocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.specificLocation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.specificLocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.specificLocation = $$c
        }
      }
    }
  }), _vm._v("\n        Import to a specific location\n      ")])]), _vm._v(" "), (_vm.specificLocation) ? _c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "file_input"
    },
    on: {
      "change": function($event) {
        _vm.processFile($event)
      }
    }
  }), (_vm.uuidFileName) ? _c('icon', {
    staticStyle: {
      "color": "green",
      "margin-left": "5px"
    },
    attrs: {
      "name": "check"
    }
  }) : _vm._e(), (_vm.error) ? _c('icon', {
    staticStyle: {
      "color": "red",
      "margin-left": "5px"
    },
    attrs: {
      "name": "exclamation-circle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Required column names: "), _c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('p', [_vm._v("Optional column names: "), _c('strong', [_vm._v("ID")]), _vm._v(", "), _c('strong', [_vm._v("Description")]), _vm._v(", "), _c('strong', [_vm._v("Component/s")]), _vm._v(", "), _c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('p', [_vm._v("You can also use the names of any of your custom attributes")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Importing\n    ")], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentProject) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-select col-md-3"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.viewOptions
    },
    model: {
      value: (_vm.currentView),
      callback: function($$v) {
        _vm.currentView = $$v
      },
      expression: "currentView"
    }
  })], 1)]), _vm._v(" "), (_vm.currentView == 'baseline-explorer') ? _c('baseline-explorer') : _vm._e(), _vm._v(" "), (_vm.currentView == 'baseline-comparison') ? _c('baseline-comparison') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(843)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      error: '',
      uuidFileName: ''
    };
  },

  methods: {
    uploadFile: function uploadFile(file, fileType, presignedUrl, uuidFileName) {
      var _this = this;

      var xhr = new XMLHttpRequest();
      xhr.open('PUT', presignedUrl);
      xhr.setRequestHeader('Content-type', fileType);
      var postData = new FormData();
      postData.append('file', file);

      var _send = xhr.send;
      xhr.send = function () {
        _send.call(xhr, file);
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 204) {
            _this.error = '';
            _this.uuidFileName = uuidFileName;
          } else {
            _this.error = 'Error uploading file';
            console.log('upload failed');
          }
        }
      };
      xhr.send(postData);
    }
  }
});

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(841)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(842)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(849)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(856)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(838)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MissingLicense__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MissingLicense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MissingLicense__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainBase__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MainBase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_entry_AuthenticateView__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_entry_AuthenticateView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_entry_AuthenticateView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_configuration_ConfigurationView__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_configuration_ConfigurationView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_configuration_ConfigurationView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuration_GettingStartedView__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuration_GettingStartedView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_configuration_GettingStartedView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_webPanels_IssueViewRequirementsRightPanelView__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_webPanels_IssueViewRequirementsRightPanelView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_webPanels_IssueViewRequirementsRightPanelView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dialogs_LinkRequirementsDialog__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_dialogs_LinkRequirementsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_dialogs_LinkRequirementsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_confluence_ConfluenceLinkedRequirementsMacroView__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_confluence_ConfluenceLinkedRequirementsMacroView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_confluence_ConfluenceLinkedRequirementsMacroView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_confluence_ConfluenceLinkedRequirementsMacroEditorView__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_confluence_ConfluenceLinkedRequirementsMacroEditorView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_confluence_ConfluenceLinkedRequirementsMacroEditorView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_confluence_ConfluenceInsertRequirementsMacroView__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_confluence_ConfluenceInsertRequirementsMacroView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_confluence_ConfluenceInsertRequirementsMacroView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_confluence_ConfluenceInsertRequirementsMacroEditorView__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_confluence_ConfluenceInsertRequirementsMacroEditorView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_confluence_ConfluenceInsertRequirementsMacroEditorView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RequirementsView__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RequirementsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_RequirementsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BaselineView__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_BaselineView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_BaselineView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TraceabilityMatrixView__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TraceabilityMatrixView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_TraceabilityMatrixView__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/authenticate/:location',
    name: 'authenticate',
    component: __WEBPACK_IMPORTED_MODULE_4__components_entry_AuthenticateView___default.a
  }, {
    path: '/configuration',
    meta: { auth: true },
    name: 'configuration',
    component: __WEBPACK_IMPORTED_MODULE_5__components_configuration_ConfigurationView___default.a
  }, {
    path: '/issue-view-requirements-right-panel',
    meta: { auth: true },
    name: 'issueViewRequirementsRightPanel',
    component: __WEBPACK_IMPORTED_MODULE_7__components_webPanels_IssueViewRequirementsRightPanelView___default.a
  }, {
    path: '/link-requirements-dialog',
    meta: { auth: true },
    name: 'linkRequirementsDialog',
    component: __WEBPACK_IMPORTED_MODULE_8__components_dialogs_LinkRequirementsDialog___default.a
  }, {
    path: '/getting-started',
    meta: { auth: true },
    name: 'gettingStarted',
    component: __WEBPACK_IMPORTED_MODULE_6__components_configuration_GettingStartedView___default.a
  }, {
    path: '/confluence-linked-requirements-macro',
    meta: { auth: true },
    name: 'confluenceLinkedRequirementsMacro',
    component: __WEBPACK_IMPORTED_MODULE_9__components_confluence_ConfluenceLinkedRequirementsMacroView___default.a
  }, {
    path: '/confluence-linked-requirements-macro-editor',
    meta: { auth: true },
    name: 'confluenceLinkedRequirementsMacroEditor',
    component: __WEBPACK_IMPORTED_MODULE_10__components_confluence_ConfluenceLinkedRequirementsMacroEditorView___default.a
  }, {
    path: '/confluence-insert-requirements-macro',
    meta: { auth: true },
    name: 'confluenceInsertRequirementsMacro',
    component: __WEBPACK_IMPORTED_MODULE_11__components_confluence_ConfluenceInsertRequirementsMacroView___default.a
  }, {
    path: '/confluence-insert-requirements-macro-editor',
    meta: { auth: true },
    name: 'confluenceInsertRequirementsMacroEditor',
    component: __WEBPACK_IMPORTED_MODULE_12__components_confluence_ConfluenceInsertRequirementsMacroEditorView___default.a
  }, {
    path: '/missing-license',
    name: 'missing-license',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MissingLicense___default.a
  }, {
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_3__components_MainBase___default.a,
    children: [{
      path: '/requirements',
      meta: { auth: true },
      name: 'requirements',
      component: __WEBPACK_IMPORTED_MODULE_13__components_RequirementsView___default.a
    }, {
      path: '/traceability-matrix',
      meta: { auth: true },
      name: 'traceabilityMatrix',
      component: __WEBPACK_IMPORTED_MODULE_15__components_TraceabilityMatrixView___default.a
    }, {
      path: '/baselines',
      meta: { auth: true },
      name: 'baselines',
      component: __WEBPACK_IMPORTED_MODULE_14__components_BaselineView___default.a
    }]
  }]
}));

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_browser__ = __webpack_require__(90);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    currentBaseline: null,
    currentBaselinePage: 'baseline-explorer',
    currentItem: null,
    currentProject: null,
    currentTab: null,
    needToRefreshItemsList: false,
    needToRefreshFolderDetail: false,
    needToRefreshRequirementsDetail: false,
    needToRefreshBaselineList: false,
    openFolderIds: {},
    projects: {},
    projectsArray: [],
    selectedFolder: null,
    selectedRequirements: []
  },
  mutations: {
    addOpenFolder: function addOpenFolder(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.openFolderIds, payload);
    },
    deleteOpenFolder: function deleteOpenFolder(state, payload) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].delete(state.openFolderIds, payload);
    },
    clearOpenFolders: function clearOpenFolders(state, payload) {
      state.openFolderIds = {};
    },
    addSelectedRequirement: function addSelectedRequirement(state, payload) {
      state.selectedRequirements = state.selectedRequirements.concat(payload);
    },
    clearSelectedRequirements: function clearSelectedRequirements(state, payload) {
      state.selectedRequirements = [];
    },
    deleteSelectedRequirement: function deleteSelectedRequirement(state, payload) {
      state.selectedRequirements.splice(state.selectedRequirements.findIndex(function (x) {
        return x === payload;
      }), 1);
    },
    setCurrentBaseline: function setCurrentBaseline(state, payload) {
      state.currentBaseline = payload;
    },
    setCurrentBaselinePage: function setCurrentBaselinePage(state, payload) {
      state.currentBaselinePage = payload;
    },
    setCurrentItem: function setCurrentItem(state, payload) {
      state.currentItem = payload;
    },
    setCurrentProject: function setCurrentProject(state, payload) {
      state.currentProject = payload;
    },
    setCurrentTab: function setCurrentTab(state, payload) {
      state.currentTab = payload;
    },
    setNeedToRefreshItemsList: function setNeedToRefreshItemsList(state, payload) {
      state.needToRefreshItemsList = payload;
    },
    setNeedToRefreshFolderDetail: function setNeedToRefreshFolderDetail(state, payload) {
      state.needToRefreshFolderDetail = payload;
    },
    setNeedToRefreshRequirementsDetail: function setNeedToRefreshRequirementsDetail(state, payload) {
      state.needToRefreshRequirementsDetail = payload;
    },
    setNeedToRefreshBaselineList: function setNeedToRefreshBaselineList(state, payload) {
      state.needToRefreshBaselineList = payload;
    },
    setProjects: function setProjects(state, payload) {
      state.projects = payload;
    },
    setProjectsArray: function setProjectsArray(state, payload) {
      state.projectsArray = payload;
    },
    setSelectedFolder: function setSelectedFolder(state, payload) {
      state.selectedFolder = payload;
    }
  },
  actions: {
    refreshProjects: function refreshProjects(_ref) {
      var commit = _ref.commit;

      var globalProjectId = 0;
      var globalProjectName = 'Global Requirements';
      var globalProject = { id: globalProjectId, name: globalProjectName };
      var projectLookup = {};
      var projectsArray = [];
      var getProjectData = function getProjectData() {
        var startAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var maxResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

        window.AP.request({
          url: '/rest/api/3/project/search?startAt=' + startAt + '&maxResults=' + maxResults,
          success: function success(response) {
            var data = JSON.parse(response);
            data.values.forEach(function (i) {
              projectLookup[i.id] = i;
              projectsArray.push({ 'text': i.name, 'value': i });
            });
            if (data.isLast === true) {
              projectLookup[globalProjectId] = globalProject;
              commit('setProjects', projectLookup);
              projectsArray.unshift({ text: globalProjectName, value: globalProject });
              projectsArray.unshift({ text: 'Select a project', value: null, disabled: true });
              commit('setProjectsArray', projectsArray);
            } else {
              getProjectData(startAt + maxResults, maxResults);
            }
          },
          error: function error(response) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_browser__["c" /* captureMessage */](response);
          }
        });
      };
      if (typeof window.AP !== 'undefined') {
        getProjectData();
      } else {
        setTimeout(getProjectData, 250);
      }
    },
    setCurrentProject: function setCurrentProject(_ref2, projectId) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.projects).length === 0) {
        var globalProjectId = 0;
        var globalProjectName = 'Global Requirements';
        var globalProject = { id: globalProjectId, name: globalProjectName };
        var projectLookup = {};
        var projectsArray = [];
        var getProjectData = function getProjectData() {
          var startAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var maxResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

          window.AP.request({
            url: '/rest/api/3/project/search?startAt=' + startAt + '&maxResults=' + maxResults,
            success: function success(response) {
              var data = JSON.parse(response);
              data.values.forEach(function (i) {
                projectLookup[i.id] = i;
                projectsArray.push({ 'text': i.name, 'value': i });
              });
              if (data.isLast === true) {
                projectLookup[globalProjectId] = globalProject;
                commit('setProjects', projectLookup);
                var projectObj = projectLookup[projectId.toString()];
                commit('setCurrentProject', projectObj);
                projectsArray.unshift({ text: globalProjectName, value: globalProject });
                projectsArray.unshift({ text: 'Select a project', value: null, disabled: true });
                commit('setProjectsArray', projectsArray);
              } else {
                getProjectData(startAt + maxResults, maxResults);
              }
            },
            error: function error(response) {
              __WEBPACK_IMPORTED_MODULE_3__sentry_browser__["c" /* captureMessage */](response);
            }
          });
        };
        if (typeof window.AP !== 'undefined') {
          getProjectData();
        } else {
          setTimeout(getProjectData, 250);
        }
      } else {
        var projectObj = state.projects[projectId.toString()];
        commit('setCurrentProject', projectObj);
      }
    }
  },
  strict: "production" !== 'production'
}));

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(839)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_polyfill__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sentry_browser__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sentry_integrations__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_spinner__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_folder_o__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_minus_square_o__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_plus_square_o__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_download__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_trash_o__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_file_text_o__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_warning__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_awesome_icons_info_circle__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_awesome_icons_check__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_awesome_icons_exclamation_circle__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_awesome_icons_chevron_down__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_awesome_icons_chevron_up__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_awesome_icons_question_circle__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_awesome_icons_search_plus__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_awesome_icons_pencil__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_awesome_components_Icon__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_aui_replacement_css__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_aui_replacement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_aui_replacement_css__);










































__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_32_vue_awesome_components_Icon___default.a);

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = "https://www.rmclouds.com";
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].prototype.$lodash = { isEqual: __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default.a, range: __WEBPACK_IMPORTED_MODULE_4_lodash_range___default.a };

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
  id: "UA-111030376-1",
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */]
});






__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default.a, {
  auth: __webpack_require__(315),
  http: __webpack_require__(316),
  router: __webpack_require__(317),
  tokenName: 'rmcloud_token',
  authRedirect: { path: '/authenticate' },
  refreshData: { url: 'api/refresh', interval: 1440 },
  loginData: { fetchUser: false },
  fetchData: { url: 'api/user' },
  tokenExpired: function tokenExpired() {
    return false;
  }
});

__WEBPACK_IMPORTED_MODULE_11__sentry_browser__["a" /* init */]({
  dsn: 'https://4f98df9c817046d2b6c140c71c1f15ec@o395945.ingest.sentry.io/5248638',

  release: "17a4551a922c230a6ff269d78f5b69c4a8631d2a" || undefined,
  integrations: [new __WEBPACK_IMPORTED_MODULE_12__sentry_integrations__["a" /* Vue */]({ Vue: __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */], attachProps: true, logErrors: true })]
});

__WEBPACK_IMPORTED_MODULE_11__sentry_browser__["b" /* configureScope */](function (scope) {
  scope.setExtra('vuex', __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */].state);
});

new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_13__components_App_vue___default.a }
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(490);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_group__ = __webpack_require__(493);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_group__["a" /* default */]);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(496);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(524);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(543);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(546);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);




var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      maintenanceMode: false
    };
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  data: function data() {
    return {
      selectedProject: null
    };
  },
  mounted: function mounted() {
    this.selectedProject = this.currentProject;
    this.backupResizeToParentInCaseAuthViewOneFails();
  },

  watch: {
    currentProject: function currentProject(newValue, oldValue) {
      if (this.selectedProject && newValue) {
        if (this.selectedProject.id.toString() !== newValue.id.toString()) {
          this.selectedProject = this.projects[newValue.id.toString()];
        }
      } else if (!this.selectedProject) {
        this.selectedProject = this.projects[newValue.id.toString()];
      }
    },
    selectedProject: function selectedProject(newValue, oldValue) {
      var currentState = window.AP.history.getState();
      if (!currentState) {
        console.log('No current state in selectedProject');
        return;
      }
      var itemParams = currentState.split('-');
      if (!oldValue && this.currentProject && newValue && this.currentProject.id.toString() === newValue.id.toString()) {
        window.AP.history.pushState(currentState);
      } else if (!oldValue || this.currentProject && newValue && this.currentProject.id.toString() !== newValue.id.toString()) {
        itemParams[0] = newValue.id;

        itemParams = itemParams.slice(0, 2);
        window.AP.history.pushState(itemParams.join('-'));
      }
    }
  },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    currentProjectIsGlobal: function currentProjectIsGlobal() {
      return this.currentProject && this.currentProject.id === 0;
    },
    currentTab: function currentTab() {
      return this.$store.state.currentTab;
    },
    projects: function projects() {
      return this.$store.state.projects;
    },
    projectsArray: function projectsArray() {
      return this.$store.state.projectsArray;
    }
  },
  methods: {
    pushTheState: function pushTheState(location) {
      window.AP.history.pushState(this.currentProject.id + '-' + location);
    }
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_getDataFromAtlassian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_utils__ = __webpack_require__(9);










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  data: function data() {
    return {
      userLookup: {},
      displayIdLookup: {},
      userAccountIdsToQuery: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      baselinesArray: [],
      baselines: [],
      combinedRequirementLookup: {},
      componentMap: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a(),
      diffLookup: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a(),
      hasResults: false,
      issueLookup: {},
      loading: false,
      reporter: null,
      requirementTypeLookup: {},
      requirementTypeLookupReady: false,
      selectedBaselinesLite: { baselineOne: null, baselineTwo: null },
      selectedBaselines: { baselineOne: null, baselineTwo: null },
      statusMap: new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a()
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_getDataFromAtlassian__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_utils__["a" /* default */]],
  methods: {
    combineIssues: function combineIssues() {
      var issueArray = [];
      var _arr = [this.selectedBaselines.baselineOne, this.selectedBaselines.baselineTwo];

      for (var _i = 0; _i < _arr.length; _i++) {
        var baseline = _arr[_i];var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(baseline.requirement_revisions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var reqRev = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(reqRev.issues), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var iss = _step2.value;

                issueArray.push(iss.atlassian_issue_id);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      this.combinedIssues = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(issueArray)));
      this.getIssueDataFromAtlassian();
    },
    getDisplayID: function getDisplayID(requirementId) {
      if (requirementId in this.displayIdLookup && this.displayIdLookup[requirementId] !== null) {
        return this.displayIdLookup[requirementId];
      } else {
        return requirementId;
      }
    },
    getDisplayIds: function getDisplayIds() {
      var _this = this;

      this.$http.post('/api/requirement/display_ids', {
        'requirementIds': __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.diffLookup.keys())
      }).then(function (response) {
        console.log(response.data);
        _this.displayIdLookup = response.data;
      }, function (response) {
        console.log('error');
      });
    },
    getAssigneeDataFromAtlassian: function getAssigneeDataFromAtlassian() {
      var _this2 = this,
          _arguments = arguments;

      this.userAccountIdsToQuery.forEach(function (accountId) {
        window.AP.request({
          url: '/rest/api/3/user?accountId=' + accountId,
          success: function success(response) {
            response = JSON.parse(response);

            _this2.$set(_this2.userLookup, accountId, response);
          },
          error: function error() {
            console.log(_arguments);
          }
        });
      });
    },
    getCombinedRequirementLookup: function getCombinedRequirementLookup() {
      var combinedRequirementLookup = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.selectedBaselines.baselineOne.requirement_revisions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var reqRev = _step3.value;

          if (combinedRequirementLookup.has(reqRev.requirement_id)) {
            combinedRequirementLookup.get(reqRev.requirement_id).baselineOne = reqRev;
          } else {
            combinedRequirementLookup.set(reqRev.requirement_id, { baselineOne: reqRev, baselineTwo: null });
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.selectedBaselines.baselineTwo.requirement_revisions), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _reqRev = _step4.value;

          if (combinedRequirementLookup.has(_reqRev.requirement_id)) {
            combinedRequirementLookup.get(_reqRev.requirement_id).baselineTwo = _reqRev;
          } else {
            combinedRequirementLookup.set(_reqRev.requirement_id, { baselineOne: null, baselineTwo: _reqRev });
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var fields = ['assigned_to', 'components', 'description', 'issues', 'name', 'status', 'contents', 'requirement_type_id', 'linked_requirements', 'attachments'];
      this.diffLookup = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(combinedRequirementLookup), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var req = _step5.value;

          var currentMap = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(fields), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var field = _step6.value;

              var baselineOne = req[1].baselineOne ? req[1].baselineOne[field] : null;
              var baselineTwo = req[1].baselineTwo ? req[1].baselineTwo[field] : null;

              if (field === 'assigned_to') {
                var _arr2 = [baselineOne, baselineTwo];

                for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
                  var bl = _arr2[_i2];
                  if (bl) {
                    this.userAccountIdsToQuery.add(bl.account_id);
                  }
                }
              }
              if (!this.$lodash.isEqual(baselineOne, baselineTwo)) {
                if (!Array.isArray(baselineOne) && baselineOne || !Array.isArray(baselineTwo) && baselineTwo || Array.isArray(baselineOne) && baselineOne.length > 0 || Array.isArray(baselineTwo) && baselineTwo.length > 0) {
                  currentMap.set(field, {
                    baselineOne: baselineOne,
                    baselineTwo: baselineTwo
                  });
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.diffLookup.set(req[0], currentMap);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.getAssigneeDataFromAtlassian();
      this.getDisplayIds();
    },
    getComponents: function getComponents() {
      var _this3 = this,
          _arguments2 = arguments;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/components',
        success: function success(response) {
          response = JSON.parse(response);
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var component = _step7.value;

              _this3.componentMap.set(component.id, component);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        },
        error: function error() {
          console.log(_arguments2);
        }
      });
    },
    getBaseline: function getBaseline(baselineObj) {
      var _this4 = this;

      var baselineId = baselineObj[0];
      var objKey = baselineObj[1];
      return this.$http.get('/api/baseline/' + baselineId + '?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this4.selectedBaselines[objKey] = response.data.baseline;
      }, function (response) {
        console.log('error');
      });
    },
    getBaselines: function getBaselines() {
      var _this5 = this;

      this.$http.get('/api/baseline?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this5.baselinesArray = response.data.baselines.map(function (i) {
          return { 'text': i.name, 'value': i };
        });
        _this5.baselines = response.data.baselines;
      }, function (response) {
        console.log('error');
      });
    },
    getIssueDataFromAtlassian: function getIssueDataFromAtlassian() {
      if (this.combinedIssues.length > 0) {
        this.getIssueDataFromAtlassianPaginated(this.combinedIssues, null, 50);
      }
    },
    goToReq: function goToReq(requirementId) {
      window.AP.history.pushState(this.currentProject.id + '-requirements-' + requirementId);
    },
    onSubmit: function onSubmit(e) {
      var _this6 = this;

      e.preventDefault();
      this.loading = true;
      this.hasResults = false;
      this.combinedRequirementLookup = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
      this.userAccountIdsToQuery = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();
      this.userLookup = {};

      var arr = [[this.selectedBaselinesLite.baselineOne.baseline_id, 'baselineOne'], [this.selectedBaselinesLite.baselineTwo.baseline_id, 'baselineTwo']];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(arr.map(this.getBaseline)).then(function (results) {
        _this6.combineIssues();
        _this6.getAssigneeDataFromAtlassian();
        _this6.getCombinedRequirementLookup();
        _this6.hasResults = true;
        _this6.loading = false;
      });
    },
    setIssues: function setIssues(response, readyToRender) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.issues), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var iss = _step8.value;

          this.$set(this.issueLookup, iss.id, iss);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    setStatusOptions: function setStatusOptions(response) {
      var _ref;

      var fullList = (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(response.map(function (issueType) {
        return issueType.statuses;
      })));
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(fullList), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var status = _step9.value;

          this.statusMap.set(status.id, status);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    getRequirementTypes: function getRequirementTypes() {
      var _this7 = this;

      this.$http.get('/api/requirement/type').then(function (response) {
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data.requirement_types), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var requirementType = _step10.value;

            _this7.requirementTypeLookup[requirementType.requirement_type_id] = requirementType;
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        _this7.requirementTypeLookupReady = true;
      }, function (error) {
        var errorString = _this7.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem retrieving your requirement types: ' + errorString,
          type: 'error'
        });
      });
    }
  },
  mounted: function mounted() {
    this.getBaselines();
    this.getRequirementTypes();

    this.getComponents();
    this.getStatusesForCurrentProject();
  },

  watch: {
    currentProject: function currentProject(currentValue) {
      if (this.currentProject) {
        this.hasResults = false;
        this.selectedBaselines = { baselineOne: null, baselineTwo: null };
        this.getBaselines();

        this.getComponents();
        this.getStatusesForCurrentProject();
      }
    }
  }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteBaselineModal__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteBaselineModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteBaselineModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_advancedFormat__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_advancedFormat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_advancedFormat__);






__WEBPACK_IMPORTED_MODULE_2_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_advancedFormat___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DeleteBaselineModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteBaselineModal___default.a },
  data: function data() {
    return {
      baseline: null,
      loading: false,
      reporter: null
    };
  },

  computed: {
    currentBaseline: function currentBaseline() {
      return this.$store.state.currentBaseline;
    },
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  mounted: function mounted() {
    this.refreshData();
  },

  watch: {
    currentBaseline: function currentBaseline(currentValue) {
      this.refreshData();
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */]],
  methods: {
    getBaseline: function getBaseline() {
      var _this = this;

      this.$http.get('/api/baseline/' + this.baselineProp.baseline_id + '/lite?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.baseline = response.data.baseline;
        _this.loading = false;
        _this.getReporterDataFromAtlassian();
      }, function (response) {
        console.log('error');
        _this.loading = false;
      });
    },
    getHumanDate: function getHumanDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_dayjs___default()(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    getReporterDataFromAtlassian: function getReporterDataFromAtlassian() {
      var _this2 = this,
          _arguments = arguments;

      if (this.baseline.created_by) {
        window.AP.request({
          url: '/rest/api/3/user?accountId=' + this.baseline.created_by.account_id,
          success: function success(response) {
            response = JSON.parse(response);
            _this2.reporter = response;
          },
          error: function error() {
            console.log(_arguments);
          }
        });
      } else {
        this.reporter = null;
      }
    },
    refreshData: function refreshData() {
      this.baseline = null;
      this.loading = true;
      this.getBaseline();
    }
  },
  props: {
    baselineProp: Object
  }
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaselineDetail_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaselineDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BaselineDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaselineList_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaselineList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BaselineList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_CreateBaselineModal__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_CreateBaselineModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_CreateBaselineModal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppNav: __WEBPACK_IMPORTED_MODULE_0__AppNav_vue___default.a, BaselineDetail: __WEBPACK_IMPORTED_MODULE_1__BaselineDetail_vue___default.a, BaselineList: __WEBPACK_IMPORTED_MODULE_2__BaselineList_vue___default.a, CreateBaselineModal: __WEBPACK_IMPORTED_MODULE_3__components_modals_CreateBaselineModal___default.a },
  data: function data() {
    return {
      baselines: []
    };
  },

  computed: {
    currentBaseline: function currentBaseline() {
      return this.$store.state.currentBaseline;
    },
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    needToRefreshBaselineList: function needToRefreshBaselineList() {
      return this.$store.state.needToRefreshBaselineList;
    }
  },
  watch: {
    currentProject: function currentProject(newValue, oldValue) {
      if (this.currentProject) {
        this.getBaselines();
        if (oldValue && oldValue.id.toString() !== newValue.id.toString()) {
          this.$store.commit('setCurrentBaseline', null);
        }
      }
    },
    needToRefreshBaselineList: function needToRefreshBaselineList(currentValue) {
      if (currentValue === true) {
        this.getBaselines();
        this.$store.commit('setNeedToRefreshBaselineList', false);
      }
    }
  },
  mounted: function mounted() {
    this.getBaselines();
  },

  methods: {
    getBaselines: function getBaselines() {
      var _this = this;

      this.$http.get('/api/baseline?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.baselines = response.data.baselines;
      }, function (response) {
        console.log('error');
      });
    }
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    baselines: Array
  },
  computed: {
    currentBaseline: function currentBaseline() {
      return this.$store.state.currentBaseline;
    },
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  methods: {
    isCurrentBaseline: function isCurrentBaseline(baseline) {
      if (this.currentBaseline) {
        return baseline.baseline_id === this.currentBaseline.baseline_id;
      }
    },
    pushTheState: function pushTheState(baseline) {
      window.AP.history.pushState(this.currentProject.id + "-baselines-" + baseline.baseline_id);
    }
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaselineComparison_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaselineComparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__BaselineComparison_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaselineExplorer_vue__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaselineExplorer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BaselineExplorer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequirementsDetail_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequirementsDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RequirementsDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemsList_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ItemsList_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { BaselineComparison: __WEBPACK_IMPORTED_MODULE_0__BaselineComparison_vue___default.a, BaselineExplorer: __WEBPACK_IMPORTED_MODULE_1__BaselineExplorer_vue___default.a, RequirementsDetail: __WEBPACK_IMPORTED_MODULE_2__RequirementsDetail_vue___default.a, ItemsList: __WEBPACK_IMPORTED_MODULE_3__ItemsList_vue___default.a },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },

    currentView: {
      get: function get() {
        return this.$store.state.currentBaselinePage;
      },
      set: function set(value) {
        this.$store.commit('setCurrentBaselinePage', value);
      }
    }
  },
  data: function data() {
    return {
      viewOptions: [{
        text: 'Baseline Explorer',
        value: 'baseline-explorer'
      }, {
        text: 'Baseline Comparison',
        value: 'baseline-comparison'
      }]
    };
  },

  watch: {
    currentView: function currentView(newValue, oldValue) {
      console.log('CHANGED', oldValue, newValue);
      if (newValue !== oldValue) {
        var currentPage = window.AP.history.getState();
        if (newValue === 'baseline-explorer' && currentPage !== 'baselines') {
          window.AP.history.pushState(this.currentProject.id + '-baselines');
        } else if (newValue === 'baseline-comparison' && currentPage !== 'comparison') {
          window.AP.history.pushState(this.currentProject.id + '-comparison');
        }
      }
    }
  }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_CreateFolderModal__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_CreateFolderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_CreateFolderModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_DeleteFolderModal__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_DeleteFolderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modals_DeleteFolderModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_EditFolderModal__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_EditFolderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_EditFolderModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_MoveFolderModal__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_MoveFolderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_MoveFolderModal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CreateFolderModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_CreateFolderModal___default.a, CreateRequirementModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal___default.a, DeleteFolderModal: __WEBPACK_IMPORTED_MODULE_2__components_modals_DeleteFolderModal___default.a, EditFolderModal: __WEBPACK_IMPORTED_MODULE_3__components_modals_EditFolderModal___default.a, MoveFolderModal: __WEBPACK_IMPORTED_MODULE_4__components_modals_MoveFolderModal___default.a },
  data: function data() {
    return {
      folder: { 'name': '' }
    };
  },

  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    needToRefreshFolderDetail: function needToRefreshFolderDetail() {
      return this.$store.state.needToRefreshFolderDetail;
    }
  },
  created: function created() {
    if (this.folderId) {
      this.refreshData();
    }
    this.$watch('folderId', this.refreshData);
  },

  watch: {
    needToRefreshFolderDetail: function needToRefreshFolderDetail(currentValue) {
      if (currentValue === true) {
        this.refreshData();
        this.$store.commit('setNeedToRefreshFolderDetail', false);
      }
    }
  },
  props: {
    folderId: Number
  },
  methods: {
    getFolder: function getFolder() {
      var _this = this;

      this.$http.get('/api/folder/' + this.folderId).then(function (response) {
        _this.folder = response.data.folder;
      }, function (response) {
        console.log('error');
      });
    },
    refreshData: function refreshData() {
      this.getFolder();
    }
  }
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      topLevel: { folder_id: null, name: 'Top Level' }
    };
  },

  name: 'folders-list',
  props: {
    currentFolder: null,
    folders: Array,
    isInnerList: false
  },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    selectedFolder: function selectedFolder() {
      return this.$store.state.selectedFolder;
    }
  },
  methods: {
    isCurrentFolder: function isCurrentFolder(folder) {
      return this.currentFolder && this.currentFolder.folder_id === folder.folder_id;
    },
    isSelectedFolder: function isSelectedFolder(folder) {
      return folder === this.selectedFolder;
    },
    toggle: function toggle(folder) {
      folder.open = !folder.open;
      if (folder.open === true) {
        this.getDescendants(folder);
      }
    },
    getDescendants: function getDescendants(folder) {
      var _this = this;

      this.$http.get('/api/folder/' + folder.folder_id + '/descendant?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.$set(folder, 'descendants', response.data.folders);
      }, function (response) {
        console.log('error');
      });
    },
    setSelectedFolder: function setSelectedFolder(folder) {
      this.$store.commit('setSelectedFolder', folder);
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, exports) {



/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteRequirementModal__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_MoveRequirementModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_MoveRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_MoveRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_utils__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { DeleteRequirementModal: __WEBPACK_IMPORTED_MODULE_0__components_modals_DeleteRequirementModal___default.a, MoveRequirementModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_MoveRequirementModal___default.a },
  name: 'items-list',
  watch: {
    selectedRequirements: function selectedRequirements(newValue, oldValue) {
      var addedRequirements = newValue.filter(function (h) {
        return !oldValue.includes(h);
      });
      var deletedRequirements = oldValue.filter(function (h) {
        return !newValue.includes(h);
      });
      if (addedRequirements.length > 0) {
        this.$store.commit('addSelectedRequirement', addedRequirements);
      } else if (deletedRequirements.length > 0) {
        this.$store.commit('deleteSelectedRequirement', deletedRequirements);
      }
    }
  },
  data: function data() {
    return {
      selectedRequirements: []
    };
  },

  props: {
    items: Array,
    isInnerList: false
  },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    currentItem: function currentItem() {
      return this.$store.state.currentItem;
    },
    openFolderIds: function openFolderIds() {
      return this.$store.state.openFolderIds;
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_utils__["a" /* default */]],
  methods: {
    isCurrentItem: function isCurrentItem(item) {
      if (this.currentItem) {
        if (item.type.endsWith('requirement')) {
          return item.requirement_id === this.currentItem.requirement_id;
        } else {
          return item.folder_id === this.currentItem.folder_id;
        }
      }
    },
    getIconClass: function getIconClass(item) {
      if (item.type === 'requirement') {
        if (item.category === 'LOW_LEVEL') {
          return 'text-secondary';
        } else if (item.category === 'HIGH_LEVEL') {
          return 'text-primary';
        } else {
          return 'text-info';
        }
      }
      return 'text-primary';
    },
    isExpandedFolder: function isExpandedFolder(item) {
      return item.type === 'folder' && this.openFolderIds && this.openFolderIds.hasOwnProperty(item.folder_id);
    },
    toggle: function toggle(item) {
      if (this.openFolderIds.hasOwnProperty(item.folder_id)) {
        this.$store.commit('deleteOpenFolder', item.folder_id);
      } else {
        this.$store.commit('addOpenFolder', item.folder_id);
        this.getFolderDescendants(item);
      }
    },
    getFolderDescendants: function getFolderDescendants(folder) {
      var _this = this;

      this.$http.get('/api/item/' + folder.folder_id + '/descendant?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.$set(folder, 'descendants', response.data.items);
      }, function (response) {
        console.log('error');
      });
    },
    getID: function getID(requirement) {
      return requirement.display_id ? requirement.display_id : requirement.requirement_id;
    },
    setCurrentItem: function setCurrentItem(item, event) {
      var target = event.target;
      if (event.target.tagName === 'path') {
        target = event.target.parentNode;
      }
      if (!target.classList.contains('prevent-this-click')) {
        this.pushTheState(item);
      }
    },
    pushTheState: function pushTheState(item) {
      var itemType = '';
      var itemId = '';
      if (item.type.endsWith('requirement')) {
        itemType = 'requirements';
        itemId = item.requirement_id;
      } else if (item.type === 'folder') {
        itemType = 'folder';
        itemId = item.folder_id;
      }
      window.AP.history.pushState(this.currentProject.id + '-' + itemType + '-' + itemId);
    }
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterView_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FooterView_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppNav: __WEBPACK_IMPORTED_MODULE_0__AppNav_vue___default.a, FooterView: __WEBPACK_IMPORTED_MODULE_1__FooterView_vue___default.a }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_advancedFormat__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_advancedFormat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_advancedFormat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_CreateRequirementModal__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_CreateRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_CreateRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_DeleteRequirementModal__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_DeleteRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_DeleteRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_EditRequirementModal__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_EditRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_EditRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_MoveRequirementModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_MoveRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_MoveRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_PreviewImageModal__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_PreviewImageModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_PreviewImageModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_getDataFromAtlassian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_uploadToS3__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_utils__ = __webpack_require__(9);







__WEBPACK_IMPORTED_MODULE_3_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_4_dayjs_plugin_advancedFormat___default.a);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CreateRequirementModal: __WEBPACK_IMPORTED_MODULE_5__components_modals_CreateRequirementModal___default.a,
    DeleteRequirementModal: __WEBPACK_IMPORTED_MODULE_6__components_modals_DeleteRequirementModal___default.a,
    EditRequirementModal: __WEBPACK_IMPORTED_MODULE_7__components_modals_EditRequirementModal___default.a,
    MoveRequirementModal: __WEBPACK_IMPORTED_MODULE_8__components_modals_MoveRequirementModal___default.a,
    PreviewImageModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_PreviewImageModal___default.a
  },
  data: function data() {
    return {
      assignee: null,
      attributes: [],
      loading: false,
      modalImageFilename: null,
      modalImageUrl: null,
      selectedComponents: [],
      selectedComponentsFull: [],
      selectedContents: [],
      selectedIssues: [],
      selectedRequirements: [],
      reporter: null,
      requirement: null,
      revisions: [],
      status: null,
      userLookup: {},
      userAccountIdsToQuery: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a()
    };
  },

  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    currentProjectIsGlobal: function currentProjectIsGlobal() {
      return this.currentProject && this.currentProject.id === 0;
    },
    needToRefreshRequirementsDetail: function needToRefreshRequirementsDetail() {
      return this.$store.state.needToRefreshRequirementsDetail;
    }
  },
  watch: {
    needToRefreshRequirementsDetail: function needToRefreshRequirementsDetail(currentValue) {
      if (currentValue === true) {
        this.refreshData();
        this.$store.commit('setNeedToRefreshRequirementsDetail', false);
      }
    }
  },
  props: {
    id: Number
  },
  created: function created() {
    if (this.id) {
      this.refreshData();
    }
    this.$watch('id', this.refreshData);
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_getDataFromAtlassian__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_uploadToS3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_utils__["a" /* default */]],
  methods: {
    clearFileInput: function clearFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    downloadFile: function downloadFile(attachment) {
      var _this = this;

      this.$http.post('/api/sign-s3-get', {
        original_file_name: attachment.original_file_name,
        uuid_file_name: attachment.uuid_file_name
      }).then(function (response) {
        _this.triggerDownload(response.data.presigned_url);
      }, function (response) {});
    },
    deleteFile: function deleteFile(attachment) {
      this.requirement.attachments.splice(this.requirement.attachments.findIndex(function (x) {
        return x.uuid_file_name === attachment.uuid_file_name;
      }), 1);
      this.updateAttachment('delete');
    },
    previewFile: function previewFile(attachment) {
      var _this2 = this;

      this.$http.post('/api/sign-s3-get', {
        original_file_name: attachment.original_file_name,
        uuid_file_name: attachment.uuid_file_name
      }).then(function (response) {
        _this2.modalImageUrl = response.data.presigned_url;
        _this2.modalImageFilename = response.data.original_file_name;
        _this2.$root.$emit('bv::show::modal', 'image-modal');
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'Error previewing attachment. Please contact rmCloud support via the "Get help" button',
          type: 'error',
          close: 'auto'
        });
      });
    },
    triggerDownload: function triggerDownload(url) {
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.download = 'test.png';
      link.href = url;
      link.click();
    },
    getAssigneeDataFromAtlassian: function getAssigneeDataFromAtlassian() {
      var _this3 = this,
          _arguments = arguments;

      if (this.requirement.assigned_to) {
        window.AP.request({
          url: '/rest/api/3/user?accountId=' + this.requirement.assigned_to.account_id,
          success: function success(response) {
            response = JSON.parse(response);
            _this3.assignee = response;
          },
          error: function error() {
            console.log(_arguments);
          }
        });
      } else {
        this.assignee = null;
      }
    },
    getReporterDataFromAtlassian: function getReporterDataFromAtlassian() {
      var _this4 = this,
          _arguments2 = arguments;

      if (this.requirement.created_by) {
        window.AP.request({
          url: '/rest/api/3/user?accountId=' + this.requirement.created_by.account_id,
          success: function success(response) {
            response = JSON.parse(response);
            _this4.reporter = response;
          },
          error: function error() {
            console.log(_arguments2);
          }
        });
      } else {
        this.reporter = null;
      }
    },
    getHumanDate: function getHumanDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_dayjs___default()(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    getIssueIds: function getIssueIds(issueObjArray) {
      return issueObjArray.map(function (d) {
        return d['atlassian_issue_id'];
      });
    },
    getSelectedComponentDataFromAtlassian: function getSelectedComponentDataFromAtlassian() {
      var _this5 = this,
          _arguments3 = arguments;

      if (this.requirement.components.length > 0) {
        window.AP.request({
          url: '/rest/api/3/project/' + this.currentProject.id + '/components',
          success: function success(response) {
            response = JSON.parse(response);
            var componentIdList = _this5.requirement.components.map(function (a) {
              return a.atlassian_component_id.toString();
            });

            _this5.selectedComponentsFull = response.filter(function (a) {
              return componentIdList.includes(a.id);
            });
            _this5.selectedComponents = _this5.selectedComponentsFull.map(function (a) {
              return a.name;
            });
          },
          error: function error() {
            console.log(_arguments3);
          }
        });
      } else {
        this.selectedComponents = [];
      }
    },
    getselectedContentsData: function getselectedContentsData() {
      var _this6 = this;

      this.selectedContents = [];
      if (this.requirement.contents.length > 0) {
        this.$http.post('/api/confluence/content/search', { contents: this.requirement.contents }).then(function (response) {
          _this6.selectedContents = response.data;
        });
      }
    },
    getStatusDataFromAtlassian: function getStatusDataFromAtlassian() {
      var _this7 = this,
          _arguments4 = arguments;

      if (this.requirement.status) {
        window.AP.request({
          url: '/rest/api/3/status/' + this.requirement.status.atlassian_status_id,
          success: function success(response) {
            response = JSON.parse(response);
            _this7.status = response;
          },
          error: function error() {
            console.log(_arguments4);
          }
        });
      } else {
        this.status = null;
      }
    },
    getSelectedIssueDataFromAtlassian: function getSelectedIssueDataFromAtlassian() {
      this.selectedIssues = [];
      if (this.requirement.issues.length > 0) {
        this.getIssueDataFromAtlassianPaginated(this.getIssueIds(this.requirement.issues), null, 50);
      }
    },
    getRequirement: function getRequirement() {
      var _this8 = this;

      this.$http.get('/api/requirement/' + this.id).then(function (response) {
        _this8.requirement = response.data.requirement;
        _this8.selectedRequirements = response.data.requirement.linked_requirements_v2;
        _this8.loading = false;

        _this8.getRevisions();
        _this8.getAssigneeDataFromAtlassian();
        _this8.getReporterDataFromAtlassian();
        _this8.getselectedContentsData();
        _this8.getSelectedIssueDataFromAtlassian();
        _this8.getSelectedComponentDataFromAtlassian();
        _this8.getStatusDataFromAtlassian();
        _this8.getAttributes();
      }, function (response) {
        console.log('error');
        _this8.loading = false;
      });
    },
    getAttributes: function getAttributes() {
      var _this9 = this;

      this.attributesLoading = true;
      this.$http.get('api/attribute?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this9.attributes = response.data.attributes;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading custom attributes.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getCustomAttributeValue: function getCustomAttributeValue(attributeDef, attributes) {
      var rawValue = attributes[attributeDef.attribute_id.toString()];
      if (attributeDef.type === 'select') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(attributeDef.options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var option = _step.value;

            if (option.attribute_option_id === rawValue) {
              return option.name;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return 'Error retrieving field data from rmCloud.  Please contact support with the "Get help" button below';
      }
      return rawValue;
    },
    getRevisions: function getRevisions() {
      var _this10 = this;

      this.$http.get('/api/requirement/' + this.requirement.requirement_id + '/revision').then(function (response) {
        _this10.revisions = response.data.revisions;
        _this10.getRevisionUserDataFromAtlassian();
      }, function (response) {
        console.log('error');
      });
    },
    getRevisionUserDataFromAtlassian: function getRevisionUserDataFromAtlassian() {
      var _this11 = this,
          _arguments5 = arguments;

      this.revisions.forEach(function (revision) {
        _this11.userAccountIdsToQuery.add(revision.account_id);
      });
      this.userAccountIdsToQuery.forEach(function (accountId) {
        window.AP.request({
          url: '/rest/api/3/user?accountId=' + accountId,
          success: function success(response) {
            response = JSON.parse(response);
            _this11.$set(_this11.userLookup, accountId, response);
          },
          error: function error() {
            console.log(_arguments5);
          }
        });
      });
    },
    getSignedRequest: function getSignedRequest(file) {
      var _this12 = this;

      this.$http.post('/api/sign-s3-put', {
        operation: 'attachment',
        original_file_name: file.name,
        file_type: file.type
      }).then(function (response) {
        _this12.uploadFile(file, file.type, response.data.presigned_url, response.data.uuid_file_name);
        _this12.requirement.attachments.push({
          original_file_name: file.name,
          uuid_file_name: response.data.uuid_file_name
        });
        _this12.updateAttachment('add');
      }, function (response) {});
    },
    goToReq: function goToReq(requirementId) {
      window.AP.history.pushState(this.currentProject.id + '-requirements-' + requirementId);
    },
    isImageFilename: function isImageFilename(filename) {
      var imageFileTypes = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(['png', 'jpeg', 'jpg']);
      var fileExt = filename.split('.').pop().toLowerCase();
      return imageFileTypes.has(fileExt);
    },
    processFile: function processFile(event) {
      var file = event.target.files[0];
      if (!file) {
        return alert('No file selected.');
      }
      if (file.size > 1024 * 1024 * 25) {
        this.clearFileInput();
        window.AP.flag.create({
          title: 'Error',
          body: 'Error adding attachment: File size cannot exceed 25MB',
          type: 'error',
          close: 'auto'
        });
      } else {
        this.getSignedRequest(file);
      }
    },
    refreshData: function refreshData() {
      this.loading = true;
      this.requirement = null;
      this.userLookup = {};
      this.getRequirement();
      this.clearFileInput();
    },
    setIssues: function setIssues(response, readyToRender) {
      var _selectedIssues;

      (_selectedIssues = this.selectedIssues).push.apply(_selectedIssues, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.issues));
    },
    updateAttachment: function updateAttachment(operation) {
      var _this13 = this;

      var successMessage = operation === 'add' ? 'Attachment added successfully' : 'Attachment deleted successfully';
      var errorMessage = operation === 'add' ? 'There was a problem adding your attachment:' : 'There was a problem deleting your attachment:';
      this.$http.patch('/api/requirement/' + this.requirement.requirement_id, {
        attachments: this.requirement.attachments
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: successMessage,
          type: 'success',
          close: 'auto'
        });
        _this13.refreshData();
      }, function (error) {
        var errorString = _this13.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: errorMessage + ' ' + errorString,
          type: 'error',
          close: 'auto'
        });
      });
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_CreateFolderModal__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_CreateFolderModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modals_CreateFolderModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_DeleteRequirementModal__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modals_DeleteRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modals_DeleteRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_ExportRequirementsModal__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_ExportRequirementsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_ExportRequirementsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FolderDetail_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FolderDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FolderDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_MoveRequirementModal__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_MoveRequirementModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_MoveRequirementModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RequirementsDetail_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RequirementsDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RequirementsDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemsList_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ItemsList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_ImportIssuesModal__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_ImportIssuesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_ImportIssuesModal__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CreateRequirementModal: __WEBPACK_IMPORTED_MODULE_1__components_modals_CreateRequirementModal___default.a,
    CreateFolderModal: __WEBPACK_IMPORTED_MODULE_2__components_modals_CreateFolderModal___default.a,
    DeleteRequirementModal: __WEBPACK_IMPORTED_MODULE_3__components_modals_DeleteRequirementModal___default.a,
    ExportRequirementsModal: __WEBPACK_IMPORTED_MODULE_4__components_modals_ExportRequirementsModal___default.a,
    FolderDetail: __WEBPACK_IMPORTED_MODULE_5__FolderDetail_vue___default.a,
    MoveRequirementModal: __WEBPACK_IMPORTED_MODULE_6__components_modals_MoveRequirementModal___default.a,
    RequirementsDetail: __WEBPACK_IMPORTED_MODULE_7__RequirementsDetail_vue___default.a,
    ImportIssuesModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_ImportIssuesModal___default.a,
    ItemsList: __WEBPACK_IMPORTED_MODULE_8__ItemsList_vue___default.a
  },
  data: function data() {
    return {
      items: [],
      loading: false
    };
  },

  computed: {
    currentItem: function currentItem() {
      return this.$store.state.currentItem;
    },
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    needToRefreshItemsList: function needToRefreshItemsList() {
      return this.$store.state.needToRefreshItemsList;
    },
    openFolderIds: function openFolderIds() {
      return this.$store.state.openFolderIds;
    },
    selectedRequirements: function selectedRequirements() {
      return this.$store.state.selectedRequirements;
    }
  },
  watch: {
    currentProject: function currentProject(newValue, oldValue) {
      if (this.currentProject) {
        if (oldValue && oldValue.id.toString() !== newValue.id.toString()) {
          window.AP.history.pushState(newValue.id + '-requirements');
        }
        this.$store.commit('clearOpenFolders');
        this.getPrimaryItems();
        this.$store.commit('clearSelectedRequirements');
      }
    },
    needToRefreshItemsList: function needToRefreshItemsList(currentValue) {
      if (currentValue === true) {
        this.getPrimaryItems();
        this.$store.commit('setNeedToRefreshItemsList', false);
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('clearOpenFolders');
    if (this.currentProject) {
      this.$store.commit('clearSelectedRequirements');
      this.getPrimaryItems();
    }
  },

  methods: {
    getPrimaryItems: function getPrimaryItems() {
      var _this = this;

      this.loading = true;
      var primaryUrl = '/api/item/primary?atlassian_project_id=' + this.currentProject.id;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.openFolderIds).length > 0 && this.openFolderIds.constructor === Object) {
        primaryUrl += '&expand=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.openFolderIds).join('&expand=');
      }
      this.$http.get(primaryUrl).then(function (response) {
        _this.items = response.data.items;
        _this.loading = false;
      }, function (response) {
        console.log('error');
      });
    }
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_getDataFromAtlassian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_utils__ = __webpack_require__(9);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TraceabilityMatrixGrid',
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    filteredRowsToIterate: function filteredRowsToIterate() {
      var data = this.rowsToIterate;
      var filterKey = this.searchQuery && this.searchQuery.toLowerCase();
      if (filterKey) {
        data = data.filter(function (row) {
          return row.requirements.some(function (requirement) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(requirement).some(function (key) {
              return String(requirement[key]).toLowerCase().indexOf(filterKey) > -1;
            });
          });
        });
      }
      return data;
    }
  },
  props: {
    searchQuery: String,
    selectedIssueTypeColumns: Array
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_getDataFromAtlassian__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_utils__["a" /* default */]],
  watch: {
    currentProject: function currentProject(currentValue) {
      if (this.currentProject) {
        this.clearData();
        this.getRequirements();
      }
    }
  },
  data: function data() {
    return {
      baseUrl: null,
      combinedIssues: [],
      headerRow: [],
      issueLookup: {},
      loading: false,
      rows: [],
      rowsToIterate: [],
      statusMap: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()
    };
  },

  methods: {
    clearData: function clearData() {
      this.headerRow = [];
      this.issueLookup = {};
      this.rows = [];
      this.rowsToIterate = [];
    },
    combineIssues: function combineIssues() {
      var issueArray = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.rows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(row.issues), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var iss = _step2.value;

              issueArray.push(iss.atlassian_issue_id);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.combinedIssues = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(issueArray)));
    },
    getBaseUrl: function getBaseUrl() {
      var _this = this;

      window.AP.getLocation(function (location) {
        var url = new URL(location);
        _this.baseUrl = url.origin;
      });
    },
    getIssueDataFromAtlassian: function getIssueDataFromAtlassian() {
      if (this.combinedIssues.length > 0) {
        this.getIssueDataFromAtlassianPaginated(this.combinedIssues, null, 50);
      } else {
        this.rowsToIterate = this.rows;
      }
    },
    getLozengeClassFromStatusCategory: function getLozengeClassFromStatusCategory(statusCategoryKey) {
      switch (statusCategoryKey) {
        case 'new':
          {
            return 'rm-lozenge';
          }
        case 'done':
          {
            return 'rm-lozenge rm-lozenge-success';
          }
        case 'indeterminate':
          {
            return 'rm-lozenge rm-lozenge-current';
          }
        default:
          {
            return 'rm-lozenge';
          }
      }
    },
    getNewTabLink: function getNewTabLink(requirementId) {
      return this.baseUrl + '/plugins/servlet/ac/' + "rmcloud" + '/rmcloud?ac.projectId=' + this.currentProject.id + '&ac.requirementId=' + requirementId;
    },
    getRequirements: function getRequirements() {
      var _this2 = this;

      this.loading = true;
      this.$http.get('/api/requirement/matrix?atlassian_project_id=' + this.currentProject.id, {
        params: {
          atlassian_project_id: this.currentProject.id
        }
      }).then(function (response) {
        _this2.rows = response.data.rows;
        _this2.requirementTypes = response.data.requirement_types;
        _this2.headerRow = response.data.header_row;
        _this2.combineIssues();
        _this2.getIssueDataFromAtlassian();
        _this2.loading = false;
      }, function (response) {
        console.log('error');
      });
    },
    setIssues: function setIssues(response, readyToRender) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.issues), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var iss = _step3.value;

          this.issueLookup[iss.id] = iss;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (readyToRender) {
        this.rowsToIterate = this.rows;
      }
    },
    setStatusOptions: function setStatusOptions(response) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var status = _step4.value;

          this.statusMap.set(status.id, status);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getBaseUrl();
    this.getRequirements();
    this.getAllStatuses();
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TraceabilityMatrixGrid__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TraceabilityMatrixGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TraceabilityMatrixGrid__);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    currentProjectIsGlobal: function currentProjectIsGlobal() {
      return this.currentProject && this.currentProject.id === 0;
    }
  },
  watch: {
    currentProject: function currentProject(currentValue) {
      if (this.currentProject) {
        this.clearData();

        if (this.currentProjectIsGlobal) {
          this.getAllIssueTypes();
        } else {
          this.getIssueTypes();
        }
      }
    },
    selectedIssueTypeColumns: function selectedIssueTypeColumns(newValue) {
      var theJson = JSON.parse(localStorage.getItem('selectedIssueTypes'));
      if (!theJson) {
        theJson = {};
      }
      theJson[this.currentProject.id] = newValue.map(function (a) {
        return a.id;
      });
      localStorage.setItem('selectedIssueTypes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(theJson));
    }
  },
  mounted: function mounted() {
    if (this.currentProjectIsGlobal) {
      this.getAllIssueTypes();
    } else {
      this.getIssueTypes();
    }
  },

  components: { TraceabilityMatrixGrid: __WEBPACK_IMPORTED_MODULE_1__TraceabilityMatrixGrid___default.a },
  data: function data() {
    return {
      issueTypeColumnOptions: [],
      jobId: null,
      loading: false,
      presignedUrl: null,
      progressValue: 0,
      selectedIssueTypeColumns: [],
      searchQuery: ''
    };
  },

  methods: {
    clearData: function clearData() {
      this.issueTypeColumnOptions = [];
      this.jobId = null;
      this.presignedUrl = null;
      this.progressValue = 0;
    },
    downloadDocx: function downloadDocx() {
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.download = 'test.png';
      link.href = this.presignedUrl;
      link.click();
      this.loading = false;
    },
    getIssueTypes: function getIssueTypes() {
      var _this = this,
          _arguments = arguments;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id,
        success: function success(response) {
          response = JSON.parse(response);
          var issueTypesSorted = response.issueTypes.sort(function (a, b) {
            return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
          });
          _this.issueTypeColumnOptions = issueTypesSorted.map(function (i) {
            return { 'text': i.name, 'value': i };
          });
          _this.setSelectedIssueTypes(issueTypesSorted);
        },
        error: function error() {
          console.log(_arguments);
        }
      });
    },
    getAllIssueTypes: function getAllIssueTypes() {
      var _this2 = this,
          _arguments2 = arguments;

      window.AP.request({
        url: '/rest/api/3/issuetype',
        success: function success(response) {
          response = JSON.parse(response);
          var issueTypesSorted = response.sort(function (a, b) {
            return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
          });
          _this2.issueTypeColumnOptions = issueTypesSorted.map(function (i) {
            return { 'text': i.name, 'value': i };
          });
          _this2.setSelectedIssueTypes(issueTypesSorted);
        },
        error: function error() {
          console.log(_arguments2);
        }
      });
    },
    generateDocx: function generateDocx() {
      this.loading = true;
      this.getExport('docx');
    },
    getExport: function getExport(format) {
      var _this3 = this;

      this.$http.post('/api/requirement/matrix/export', {
        atlassian_project_id: this.currentProject.id,
        type: format,
        selected_issue_types: this.selectedIssueTypeColumns
      }).then(function (response) {
        if (format === 'docx') {
          _this3.presignedUrl = response.data.presigned_url;
          _this3.jobId = response.data.job_id;
          _this3.updateProgress();
        }
      }, function (response) {
        _this3.loading = false;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
          type: 'error',
          close: 'auto'
        });
      });
    },
    setSelectedIssueTypes: function setSelectedIssueTypes(allIssueTypes) {
      var _this4 = this;

      if (localStorage.getItem('selectedIssueTypes')) {
        var typeIDJSON = JSON.parse(localStorage.getItem('selectedIssueTypes'));
        if (this.currentProject.id in typeIDJSON) {
          this.selectedIssueTypeColumns = allIssueTypes.filter(function (s) {
            return typeIDJSON[_this4.currentProject.id].includes(s.id);
          });
        } else {
          this.selectedIssueTypeColumns = allIssueTypes;
        }
      } else {
        this.selectedIssueTypeColumns = allIssueTypes;
      }
    },
    updateProgress: function updateProgress() {
      var _this5 = this;

      this.$http.get('/api/job/status/' + this.jobId).then(function (response) {
        if (response.data.status !== 'queued' && response.data.status !== 'started') {
          _this5.loading = false;
          _this5.progressValue = 0;
          if (response.data.status === 'finished') {
            _this5.downloadDocx();
          } else {
            window.AP.flag.create({
              title: 'Error',
              body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
              type: 'error',
              close: 'auto'
            });
          }
        } else {
          _this5.progressValue = response.data.completed_rows * 100 / response.data.total_rows;
          setTimeout(function () {
            _this5.updateProgress();
          }, 2000);
        }
      }, function (response) {
        console.log('error');
        _this5.loading = false;
        _this5.progressValue = 0;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error generating your exported file. Please contact rmCloud support via the "Get help" button',
          type: 'error',
          close: 'auto'
        });
      });
    }
  }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomAttributesView__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomAttributesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CustomAttributesView__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CustomAttributesView: __WEBPACK_IMPORTED_MODULE_2__CustomAttributesView___default.a, RequirementTypesView: __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  data: function data() {
    return {
      commentOnAssociatedIssues: null,
      sendEmailNotificationToAssignee: null,
      confluenceSpacesToFilter: ''
    };
  },

  methods: {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.patchUpdateCustomer();
    },
    patchUpdateCustomer: function patchUpdateCustomer() {
      var _this = this;

      this.$http.patch('/api/customer/settings', {
        comment_on_associated_issues: this.commentOnAssociatedIssues,
        send_email_notification_to_assignee: this.sendEmailNotificationToAssignee,
        confluence_spaces_to_filter: this.confluenceSpacesToFilter
      }).then(function (response) {
        _this.$auth.user().comment_on_associated_issues = response.data.comment_on_associated_issues;
        _this.$auth.user().send_email_notification_to_assignee = response.data.send_email_notification_to_assignee;
        window.AP.flag.create({
          title: 'Success!',
          body: 'Settings saved successfully',
          type: 'success',
          close: 'auto'
        });
      }, function (response) {
        console.log('fail');
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error saving your settings',
          type: 'error',
          close: 'auto'
        });
      });
    }
  },
  mounted: function mounted() {
    this.commentOnAssociatedIssues = this.$auth.user()['comment_on_associated_issues'];
    this.sendEmailNotificationToAssignee = this.$auth.user()['send_email_notification_to_assignee'];
    this.confluenceSpacesToFilter = this.$auth.user()['confluence_spaces_to_filter'];
    this.backupResizeToParentInCaseAuthViewOneFails();
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      attributeOptionToAdd: '',
      attributes: [],
      newAttributeLoading: false,
      newAttributeName: null,
      newAttributeOptions: [],
      newAttributeProject: null,
      newAttributeType: 'string',
      projectLookup: {},
      projectsArray: [],
      projectsLoading: true,
      showNewAttributeForm: false,
      typeOptions: [{ value: 'string', text: 'Standard field type' }, { value: 'select', text: 'Field with pre-defined options' }]
    };
  },

  computed: {
    shouldDisableSubmitButton: function shouldDisableSubmitButton() {
      if (!this.newAttributeName) {
        return true;
      }
      if (!this.newAttributeProject) {
        return true;
      }
      if (this.newAttributeType === 'select') {
        if (this.newAttributeOptions.length < 1 || this.newAttributeOptions.length > 10) {
          return true;
        }
      }
      return false;
    },
    shouldDisableAddButton: function shouldDisableAddButton() {
      if (this.newAttributeOptions.length >= 10) {
        return true;
      }
      return this.attributeOptionToAdd.length <= 0 || this.attributeOptionToAdd.length > 75;
    },
    nameState: function nameState() {
      return this.attributeOptionToAdd.length <= 75;
    },
    activeAttributes: function activeAttributes() {
      var _this = this;

      return this.attributes.filter(function (attribute) {
        return _this.projectLookup.hasOwnProperty(attribute.atlassian_project_id);
      });
    }
  },
  methods: {
    createAttribute: function createAttribute() {
      var _this2 = this;

      this.newAttributeLoading = true;
      var payload = {
        name: this.newAttributeName,
        project: this.newAttributeProject,
        type: this.newAttributeType
      };
      if (this.newAttributeType === 'select') {
        payload['options'] = this.newAttributeOptions;
      }
      this.$http.post('/api/attribute', payload).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Custom field created successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.newAttributeLoading = false;
        _this2.getAttributes();
        _this2.disableNewAttributeForm();
      }, function (error) {
        _this2.newAttributeLoading = false;
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your custom field: ' + errorString,
          type: 'error'
        });
      });
    },
    deleteAttribute: function deleteAttribute(attributeId) {
      var _this3 = this;

      if (!confirm('Are you sure you want to delete this field and all data associated with it?')) {
        return;
      }
      this.newAttributeLoading = true;
      this.$http.delete('/api/attribute/' + attributeId).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Custom field deleted successfully',
          type: 'success',
          close: 'auto'
        });
        _this3.newAttributeLoading = false;
        _this3.getAttributes();
      }, function (error) {
        _this3.newAttributeLoading = false;
        var errorString = _this3.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem deleting your custom field: ' + errorString,
          type: 'error'
        });
      });
    },
    getAttributes: function getAttributes() {
      var _this4 = this;

      this.$http.get('/api/attribute').then(function (response) {
        _this4.attributes = response.data.attributes;
      }, function (error) {
        var errorString = _this4.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem retrieving your custom fields: ' + errorString,
          type: 'error'
        });
      });
    },
    enableNewAttributeForm: function enableNewAttributeForm() {
      this.showNewAttributeForm = true;
    },
    disableNewAttributeForm: function disableNewAttributeForm() {
      this.showNewAttributeForm = false;
      this.newAttributeName = null;
      this.newAttributeProject = null;
      this.newAttributeOptions = [];
      this.newAttributeType = 'string';
    },
    getProjects: function getProjects() {
      var _this5 = this,
          _arguments = arguments;

      var startAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var maxResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

      window.AP.request({
        url: '/rest/api/3/project/search?startAt=' + startAt + '&maxResults=' + maxResults,
        success: function success(response) {
          var parsedResponse = JSON.parse(response);
          parsedResponse.values.forEach(function (i) {
            _this5.$set(_this5.projectLookup, i.id, i);
            _this5.projectsArray.push({ 'text': i.name, 'value': i });
          });
          if (parsedResponse.isLast === true) {
            _this5.projectsArray.unshift({ text: 'Select a project', value: null, disabled: true });
            _this5.projectsLoading = false;
          } else {
            _this5.getProjects(startAt + maxResults, maxResults);
          }
        },
        error: function error() {
          console.log(_arguments);
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem retrieving your project data from Atlassian',
            type: 'error'
          });
        }
      });
    },
    addAttributeOption: function addAttributeOption() {
      this.newAttributeOptions.push(this.attributeOptionToAdd);
      this.attributeOptionToAdd = '';
    }
  },
  mounted: function mounted() {
    this.getAttributes();
    this.getProjects();
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  mounted: function mounted() {
    this.backupResizeToParentInCaseAuthViewOneFails();
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { RequirementTypesView: __WEBPACK_IMPORTED_MODULE_1__components_configuration_RequirementTypesView___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  data: function data() {
    return {
      requirementTypes: [],
      newRequirementTypeName: null,
      newRequirementTypePrefix: null,
      newRequirementTypeLoading: false,
      showNewRequirementTypeForm: false,
      currentlyEditingARequirementType: false,
      requirementTypeIdBeingEdited: null,
      updateRequirementTypeName: null,
      updateRequirementTypePrefix: null,
      updateRequirementTypeLevel: null,
      updateRequirementTypeLoading: false,
      deleteRequirementTypeLoading: false
    };
  },

  methods: {
    createRequirementType: function createRequirementType() {
      var _this = this;

      this.newRequirementTypeLoading = true;
      this.$http.post('/api/requirement/type', {
        requirement_type: {
          name: this.newRequirementTypeName,
          prefix: this.newRequirementTypePrefix }
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Requirement type created successfully',
          type: 'success',
          close: 'auto'
        });
        _this.newRequirementTypeLoading = false;
        _this.getRequirementTypes();
        _this.disableNewRequirementTypeForm();
      }, function (error) {
        _this.newRequirementTypeLoading = false;
        var errorString = _this.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your requirement type: ' + errorString,
          type: 'error'
        });
      });
    },
    updateRequirementType: function updateRequirementType(requirementTypeId) {
      var _this2 = this;

      this.updateRequirementTypeLoading = true;
      this.$http.put('/api/requirement/type/' + requirementTypeId, {
        requirement_type: {
          name: this.updateRequirementTypeName,
          prefix: this.updateRequirementTypePrefix,
          level: this.updateRequirementTypeLevel
        }
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Requirement type updated successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.updateRequirementTypeLoading = false;
        _this2.getRequirementTypes();
        _this2.disableUpdateRequirementTypeForm();
      }, function (error) {
        _this2.updateRequirementTypeLoading = false;
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        if (error.response.data && error.response.data.requirement_type) {
          errorString = _this2.createErrorStringFromResponse(error.response.data.requirement_type);
        }
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your requirement type: ' + errorString,
          type: 'error'
        });
      });
    },
    deleteRequirementType: function deleteRequirementType(requirementTypeId) {
      var _this3 = this;

      if (!confirm('Are you sure you want to delete this requirement type? This operation is only allowed if there are no active requirements with this type.')) {
        return;
      }
      this.deleteRequirementTypeLoading = true;
      this.$http.delete('/api/requirement/type/' + requirementTypeId).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Requirement type deleted successfully',
          type: 'success',
          close: 'auto'
        });
        _this3.deleteRequirementTypeLoading = false;
        _this3.getRequirementTypes();
      }, function (error) {
        _this3.deleteRequirementTypeLoading = false;
        var errorString = _this3.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem deleting your requirement type: ' + errorString,
          type: 'error'
        });
      });
    },
    getRequirementTypes: function getRequirementTypes() {
      var _this4 = this;

      this.$http.get('/api/requirement/type').then(function (response) {
        _this4.requirementTypes = response.data.requirement_types;
      }, function (error) {
        var errorString = _this4.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem retrieving your requirement types: ' + errorString,
          type: 'error'
        });
      });
    },
    enableNewRequirementTypeForm: function enableNewRequirementTypeForm() {
      this.showNewRequirementTypeForm = true;
    },
    disableNewRequirementTypeForm: function disableNewRequirementTypeForm() {
      this.showNewRequirementTypeForm = false;
      this.newRequirementTypeName = null;
      this.newRequirementTypePrefix = null;
    },
    enableUpdateRequirementTypeForm: function enableUpdateRequirementTypeForm(requirementType) {
      this.currentlyEditingARequirementType = true;
      this.requirementTypeIdBeingEdited = requirementType.requirement_type_id;
      this.updateRequirementTypeName = requirementType.name;
      this.updateRequirementTypePrefix = requirementType.prefix;
      this.updateRequirementTypeLevel = requirementType.level;
    },
    disableUpdateRequirementTypeForm: function disableUpdateRequirementTypeForm() {
      this.currentlyEditingARequirementType = false;
      this.requirementTypeIdBeingEdited = null;
      this.updateRequirementTypeName = null;
      this.updateRequirementTypePrefix = null;
      this.updateRequirementTypeLevel = null;
    }
  },
  mounted: function mounted() {
    this.getRequirementTypes();
  }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_utils__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      requirements: [],
      selectedRequirements: []
    };
  },
  created: function created() {
    this.getRequirements();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_utils__["a" /* default */]],
  methods: {
    bindButton: function bindButton() {
      var _this = this;

      window.AP.require(['confluence', 'dialog'], function (confluence, dialog) {
        confluence.getMacroData(function (macroParams) {
          if (macroParams && macroParams.requirementIds && macroParams.requirementIds.length > 0) {
            var requirementIdNumbers = macroParams.requirementIds.split(',').map(function (s) {
              return Number(s);
            });
            _this.selectedRequirements = _this.requirements.filter(function (r) {
              return requirementIdNumbers.includes(r.requirement_id);
            });
          }
        });
        dialog.getButton('submit').bind(function (target) {
          confluence.saveMacro({ 'requirementIds': _this.selectedRequirements.map(function (s) {
              return s.requirement_id.toString();
            }).join(',') });
          confluence.closeMacroEditor();
          return true;
        });
      });
    },
    getRequirements: function getRequirements() {
      var _this2 = this;

      this.$http.get('/api/requirement/lite').then(function (response) {
        _this2.requirements = response.data.requirements;
        _this2.bindButton();
      }, function (response) {
        console.log('error');
      });
    }
  }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedRequirements: []
    };
  },
  created: function created() {
    this.getIdsFromMacro();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    getIdsFromMacro: function getIdsFromMacro() {
      var _this = this;

      window.AP.require('request', function (request) {
        var pageId = _this.getUrlParam('pageId');
        var pageVersion = _this.getUrlParam('pageVersion');
        var macroId = _this.getUrlParam('macroId');
        request({
          url: '/rest/api/content/' + pageId + '/history/' + pageVersion + '/macro/id/' + macroId,
          success: function success(response) {
            var macro = JSON.parse(response);
            var requirementIds = macro.parameters.requirementIds.value.split(',').map(function (s) {
              return Number(s);
            });
            _this.getLinkedRequirements(requirementIds);
          }
        });
      });
    },
    getUrlVars: function getUrlVars() {
      var vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
      });
      return vars;
    },
    getUrlParam: function getUrlParam(parameter, defaultvalue) {
      var urlparameter = defaultvalue;
      if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = this.getUrlVars()[parameter];
      }
      return urlparameter;
    },
    getLinkedRequirements: function getLinkedRequirements(requirementIds) {
      var _this2 = this;

      this.$http.post('/api/requirement/by-id/lite', { 'requirementIds': requirementIds }).then(function (response) {
        _this2.selectedRequirements = response.data.requirements;
      }, function (response) {
        console.log('error');
      });
    }
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_utils__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      requirements: [],
      selectedRequirements: [],
      contentId: null
    };
  },
  created: function created() {
    this.getContext();
    this.bindButton();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_utils__["a" /* default */]],
  methods: {
    bindButton: function bindButton() {
      var _this = this;

      window.AP.require(['confluence', 'dialog'], function (confluence, dialog) {
        dialog.getButton('submit').bind(function (target) {
          _this.$http.put('/api/confluence/content/' + _this.contentId, {
            requirements: _this.selectedRequirements
          });
          confluence.saveMacro({});
          confluence.closeMacroEditor();
          return true;
        });
      });
    },
    getLinkedRequirements: function getLinkedRequirements() {
      var _this2 = this;

      this.$http.get('/api/requirement/lite?atlassian_content_id=' + this.contentId).then(function (response) {
        _this2.selectedRequirements = response.data.requirements;
      }, function (response) {
        console.log('error');
      });
    },
    getRequirements: function getRequirements() {
      var _this3 = this;

      this.$http.get('/api/requirement/lite').then(function (response) {
        _this3.requirements = response.data.requirements;
        _this3.getLinkedRequirements();
      }, function (response) {
        console.log('error');
      });
    },
    getContext: function getContext() {
      var _this4 = this;

      window.AP.navigator.getLocation(function (location) {
        _this4.contentId = location.context.contentId;
        _this4.getRequirements();
      });
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      selectedRequirements: [],
      contentId: this.$route.query.contentId
    };
  },
  created: function created() {
    this.getLinkedRequirements();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    getLinkedRequirements: function getLinkedRequirements() {
      var _this = this;

      this.$http.get('/api/requirement/lite?atlassian_content_id=' + this.contentId).then(function (response) {
        _this.selectedRequirements = response.data.requirements;
      }, function (response) {
        console.log('error');
      });
    }
  }
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      requirements: [],
      selectedRequirements: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */]],
  mounted: function mounted() {
    this.waitForAP();
    this.bindButtons();
  },

  methods: {
    bindButtons: function bindButtons() {
      var _this = this;

      window.AP.dialog.disableCloseOnSubmit();
      window.AP.events.on('dialog.submit', function () {
        if (!_this.loading) {
          _this.loading = true;
          _this.submitData();
        }
      });
    },
    customRequirementLabel: function customRequirementLabel(requirement) {
      var idToShow = requirement.display_id ? requirement.display_id : requirement.requirement_id;
      return '' + requirement.prefix + idToShow + ': ' + requirement.name;
    },
    getLinkedRequirements: function getLinkedRequirements() {
      var _this2 = this;

      this.$http.get('/api/requirement?atlassian_project_id=' + this.projectId + '&atlassian_project_id=0&atlassian_issue_id=' + this.issueId).then(function (response) {
        _this2.selectedRequirements = response.data.requirements;
        _this2.loading = false;
      }, function (response) {
        console.log('error');
      });
    },
    getRequirements: function getRequirements() {
      var _this3 = this;

      this.$http.get('/api/requirement?atlassian_project_id=' + this.projectId + '&atlassian_project_id=0').then(function (response) {
        _this3.requirements = response.data.requirements;
        _this3.getLinkedRequirements();
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error loading your requirements.  Please contact rmCloud support: support@purpledrapes.net',
          type: 'error'
        });
      });
    },
    waitForAP: function waitForAP() {
      var _this4 = this;

      if (typeof window.AP !== 'undefined') {
        window.AP.dialog.getCustomData(function (customData) {
          _this4.issueId = customData.issueId;
          _this4.projectId = customData.projectId;
          _this4.getRequirements();
        });
      } else {
        setTimeout(this.waitForAP, 250);
      }
    },
    submitData: function submitData() {
      var _this5 = this;

      this.$http.put('/api/issue/' + this.issueId, {
        requirements: this.selectedRequirements
      }).then(function (response) {
        _this5.loading = false;
        window.AP.flag.create({
          title: 'Success!',
          body: 'Linked requirements saved successfully',
          type: 'success',
          close: 'auto'
        });
        window.AP.dialog.close();
      }, function (response) {
        _this5.loading = false;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error saving your linked requirements.  Please contact rmCloud support: support@purpledrapes.net',
          type: 'error'
        });
      });
    }
  }
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      authError: null
    };
  },
  created: function created() {
    var _this = this;

    var location = 'requirements';
    var product = 'jira';
    if (this.$route.params.location === 'configuration') {
      location = 'configuration';
    } else if (this.$route.params.location === 'issue-view-requirements-right-panel') {
      location = 'issueViewRequirementsRightPanel';
    } else if (this.$route.params.location === 'confluence-linked-requirements-macro-editor') {
      location = 'confluenceLinkedRequirementsMacroEditor';
      product = 'confluence';
    } else if (this.$route.params.location === 'confluence-linked-requirements-macro') {
      location = 'confluenceLinkedRequirementsMacro';
      product = 'confluence';
    } else if (this.$route.params.location === 'confluence-insert-requirements-macro-editor') {
      location = 'confluenceInsertRequirementsMacroEditor';
      product = 'confluence';
    } else if (this.$route.params.location === 'confluence-insert-requirements-macro') {
      location = 'confluenceInsertRequirementsMacro';
      product = 'confluence';
    } else if (this.$route.params.location === 'getting-started') {
      location = 'gettingStarted';
    } else if (this.$route.params.location === 'link-requirements-dialog') {
      location = 'linkRequirementsDialog';
    }
    if (product === 'jira') {
      window.AP.sizeToParent();
    }
    var loginObj = {
      data: {
        fullPath: this.$route.fullPath,
        method: 'GET',
        product: product
      },
      success: function success() {
        if (location === 'requirements') {
          var currentState = window.AP.history.getState();
          if (currentState) {
            _this.setStateFromStateString(currentState);
          } else if (_this.$route.query.projectId && _this.$route.query.requirementId) {
            window.AP.history.pushState(_this.$route.query.projectId + '-requirements-' + _this.$route.query.requirementId);
            _this.setStateFromStateString(_this.$route.query.projectId + '-requirements-' + _this.$route.query.requirementId);
          } else if (_this.$route.query.projectId) {
            window.AP.history.pushState(_this.$route.query.projectId + '-requirements');
            _this.setStateFromStateString(_this.$route.query.projectId + '-requirements');
          } else {
            window.AP.history.pushState('-requirements');
          }
          _this.$store.dispatch('refreshProjects');
          _this.createHistoryListener();
        }
      },
      error: function error(resp) {
        var data = resp.response && resp.response.data || {};
        var result = data.Result || data.result;
        if (result === 'license') {
          _this.$ga.event('error', 'missing-license', _this.$route.fullPath, 1);
          _this.$auth.logout({
            redirect: { name: 'missing-license' }
          });
          return;
        }

        _this.$ga.event('error', 'exchange-token', result || 'unknown', 1);
        _this.authError = result || 'unknown';
        _this.$auth.logout({ redirect: null });
      },
      redirect: { name: location, query: this.$route.query },
      rememberMe: true,
      url: '/api/exchange-token',
      fetchUser: true
    };

    if (location === 'requirements') {
      var currentState = window.AP.history.getState();
      if (currentState) {
        loginObj.redirect = null;
      }
    }
    this.$auth.login(loginObj);
  },

  methods: {
    setStateFromStateString: function setStateFromStateString(stateStr) {
      var itemParams = stateStr.split('-');

      if (itemParams[0].length > 0) {
        var projectId = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(itemParams[0]);
        var currentProject = this.$store.state.currentProject;
        if (!currentProject || currentProject.id.toString() !== projectId.toString()) {
          this.$store.dispatch('setCurrentProject', projectId);
        }
      }
      if (itemParams[1] === 'requirements' || itemParams[1] === 'folder') {
        this.$store.commit('setCurrentTab', 'requirements');
        if (itemParams.length === 3) {
          var itemKey = itemParams[1] === 'requirements' ? 'requirement_id' : 'folder_id';
          var item = {
            type: itemParams[1] === 'requirements' ? 'requirement' : 'folder'
          };
          item[itemKey] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(itemParams[2]);
          this.$store.commit('setCurrentItem', item);
        } else {
          this.$store.commit('setCurrentItem', null);
        }

        this.$router.replace('/requirements');
      } else if (itemParams[1] === 'traceability') {
        this.$store.commit('setCurrentTab', 'traceability');
        this.$router.replace('/traceability-matrix');
      } else if (itemParams[1] === 'baselines') {
        this.$store.commit('setCurrentTab', 'baselines');
        this.$store.commit('setCurrentBaselinePage', 'baseline-explorer');

        if (itemParams.length === 3) {
          var baseline = {
            baseline_id: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(itemParams[2])
          };
          this.$store.commit('setCurrentBaseline', baseline);
        } else {
          this.$store.commit('setCurrentBaseline', null);
        }
        this.$router.replace('/baselines');
      } else if (itemParams[1] === 'comparison') {
        this.$store.commit('setCurrentTab', 'baselines');
        this.$router.replace('/baselines');
        this.$store.commit('setCurrentBaselinePage', 'baseline-comparison');
      }
    },
    createHistoryListener: function createHistoryListener() {
      var _this2 = this;

      window.AP.history.popState(function (e) {
        if (e.newURL) {
          _this2.setStateFromStateString(e.newURL);
        }
      });
    }
  }
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FoldersList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FoldersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FoldersList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FoldersList: __WEBPACK_IMPORTED_MODULE_2__components_FoldersList___default.a },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    selectedFolder: function selectedFolder() {
      return this.$store.state.selectedFolder;
    }
  },
  data: function data() {
    return {
      baselineName: '',
      baselineDescription: '',
      loading: false,
      folders: [],
      requirements: [],
      selectRequirementsOption: 'all',
      selectedRequirements: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.loading = true;
        this.submitData();
      }
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    shown: function shown() {
      this.getRequirements();
      this.getPrimaryFolders();
    },
    clearModal: function clearModal() {
      var _this = this;

      this.baselineName = '';
      this.baselineDescription = '';
      this.loading = false;
      this.selectedRequirements = [];
      this.selectRequirementsOption = 'all';
      this.$store.commit('setSelectedFolder', null);
      this.$nextTick(function () {
        _this.errors.clear();
      });
    },
    customRequirementLabel: function customRequirementLabel(requirement) {
      var idToShow = requirement.display_id ? requirement.display_id : requirement.requirement_id;
      return '' + requirement.prefix + idToShow + ': ' + requirement.name;
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('baseline', 'create', this.selectRequirementsOption, 1);
      this.$http.post('/api/baseline', {
        name: this.baselineName,
        description: this.baselineDescription,
        requirements: this.selectRequirementsOption === 'individual' ? this.selectedRequirements : [],
        select_all_requirements: this.selectRequirementsOption === 'all',
        select_from_parent_folder: this.selectRequirementsOption === 'folder',
        select_from_parent_folder_id: this.selectRequirementsOption === 'folder' && this.selectedFolder ? this.selectedFolder.folder_id : null,
        project: this.currentProject
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Baseline created successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.clearModal();
        _this2.setTheState();
        _this2.$refs.createbaselinemodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your baseline: ' + errorString,
          type: 'error'
        });
        _this2.loading = false;
      });
    },
    getRequirements: function getRequirements() {
      var _this3 = this;

      this.$http.get('/api/requirement?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this3.requirements = response.data.requirements;
      }, function (response) {
        console.log('error');
      });
    },
    getPrimaryFolders: function getPrimaryFolders() {
      var _this4 = this;

      this.$http.get('/api/folder/primary?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this4.folders = response.data.folders;
      }, function (response) {
        console.log('error');
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshBaselineList', true);
    }
  }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    currentTitle: function currentTitle() {
      return this.parentFolderId ? 'Create a child folder' : 'Create a folder';
    }
  },
  data: function data() {
    return {
      folderName: '',
      loading: false
    };
  },

  props: {
    modalId: String,
    parentFolderId: {
      default: null,
      type: Number
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.loading = true;
        this.submitData();
      }
    },
    clearModal: function clearModal() {
      var _this = this;

      this.folderName = '';
      this.loading = false;
      this.$nextTick(function () {
        _this.errors.clear();
      });
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('folder', 'create', this.folderName, 1);
      this.$http.post('/api/folder', {
        name: this.folderName,
        parent_folder_id: this.parentFolderId,
        project: this.currentProject
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Folder created successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.clearModal();
        _this2.setTheState();
        _this2.$refs.createfoldermodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your folder: ' + errorString,
          type: 'error'
        });
        _this2.loading = false;
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
    }
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_utils__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  watch: {
    selectedRequirementType: function selectedRequirementType(currentValue) {
      this.selectedRequirements = [];
    }
  },
  data: function data() {
    return {};
  },

  props: {
    modalId: String,
    parentFolderId: {
      default: null,
      type: Number
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_requirementModal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.submitting = true;
        this.submitData();
      }
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    shown: function shown() {
      this.getAttributes();
      this.getIssues();
      this.getRequirements();
      this.getRequirements();
      this.getRequirementTypes();
      if (this.$auth.user().installed_on_confluence) {
        this.getContents();
      }
      if (!this.currentProjectIsGlobal) {
        this.getComponents();
        this.getStatusesForCurrentProject();
        this.getAssignees();
      }
    },
    clearModal: function clearModal() {
      var _this = this;

      this.name = '';
      this.displayID = null;
      this.description = '';
      this.submitting = false;
      this.issuesLoading = false;
      this.contentsLoading = false;
      this.statusesLoading = false;
      this.assigneesLoading = false;
      this.requirementsLoading = false;
      this.componentsLoading = false;
      this.selectedAssignee = null;
      this.selectedAttributes = {};
      this.selectedComponents = [];
      this.selectedContents = [];
      this.selectedIssues = [];
      this.selectedRequirements = [];
      this.selectedRequirementType = null;
      this.selectedStatus = null;
      this.$nextTick(function () {
        _this.errors.clear();
      });
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('requirement', 'create', this.name, 1);
      this.$http.post('/api/requirement', {
        assigned_to: this.selectedAssignee,
        attributes: this.selectedAttributes,
        components: this.selectedComponents,
        contents: this.selectedContents,
        description: this.description,
        display_id: this.displayID,
        issues: this.selectedIssues,
        name: this.name,
        project: this.currentProject,
        parent_folder_id: this.parentFolderId,
        requirements: this.selectedRequirements,
        requirement_type_id: this.selectedRequirementType.requirement_type_id,
        status: this.selectedStatus
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Requirement created successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.clearModal();
        _this2.setTheState();
        _this2.$refs.createreqmodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem saving your requirement: ' + errorString,
          type: 'error'
        });
        _this2.submitting = false;
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
    }
  }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false
    };
  },

  props: {
    baseline: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();
      this.loading = true;
      this.submitData();
    },
    submitData: function submitData() {
      var _this = this;

      this.$ga.event('baseline', 'delete', this.baseline.baseline_id, 1);
      this.$http.delete('/api/baseline/' + this.baseline.baseline_id).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Baseline deleted successfully',
          type: 'success',
          close: 'auto'
        });
        _this.loading = false;
        _this.setTheState();
        _this.$refs.deletebaselinemodal.hide();
      }, function (error) {
        var errorString = _this.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem deleting your baseline: ' + errorString,
          type: 'error'
        });
        _this.loading = false;
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshBaselineList', true);
      this.$store.commit('setCurrentBaseline', null);
    }
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false
    };
  },

  props: {
    folderId: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();
      this.loading = true;
      this.submitData();
    },
    submitData: function submitData() {
      var _this = this;

      this.$ga.event('folder', 'delete', this.folderId, 1);
      this.$http.delete('/api/folder/' + this.folderId, {}).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Folder deleted successfully',
          type: 'success',
          close: 'auto'
        });
        _this.loading = false;
        _this.setTheState();
        _this.$refs.deletefoldermodal.hide();
      }, function (error) {
        var errorString = _this.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem deleting your folder: ' + errorString,
          type: 'error'
        });
        _this.loading = false;
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
      this.$store.commit('setCurrentItem', null);
      this.$store.commit('clearSelectedRequirements');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false
    };
  },

  props: {
    modalId: String,
    requirements: Array
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();
      this.loading = true;
      this.submitData();
    },
    submitData: function submitData() {
      var _this = this;

      this.$ga.event('requirement', 'delete', this.requirements.length > 1 ? 'bulk' : 'single', 1);
      this.$http.post('/api/requirement/delete/bulk', {
        requirements: this.requirements
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: _this.requirements.length > 1 ? 'Requirements deleted successfully' : 'Requirement deleted successfully',
          type: 'success',
          close: 'auto'
        });
        _this.loading = false;
        _this.setTheState();
        _this.$refs.deleterequirementmodal.hide();
      }, function (error) {
        var errorString = _this.createErrorStringFromResponse(error.response.data);
        var requirementWord = _this.requirements.length > 1 ? 'requirements' : 'requirement';
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem deleting your ' + requirementWord + ': ' + errorString,
          type: 'error'
        });
        _this.loading = false;
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
      this.$store.commit('setCurrentItem', null);
      this.$store.commit('clearSelectedRequirements');
    }
  }
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      folder: null,
      folderName: '',
      loading: false
    };
  },

  props: {
    folderId: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.loading = true;
        this.submitData();
      }
    },
    mounted: function mounted() {
      this.getFolderData();
    },
    shown: function shown() {
      this.getFolderData();
    },
    getFolderData: function getFolderData() {
      var _this = this;

      this.$http.get('/api/folder/' + this.folderId).then(function (response) {
        _this.folder = response.data.folder;
        _this.folderName = response.data.folder.name;
      }, function (response) {});
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshFolderDetail', true);
      this.$store.commit('setNeedToRefreshItemsList', true);
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('folder', 'edit', this.folderId, 1);
      this.$http.put('/api/folder/' + this.folderId, {
        name: this.folderName,
        description: this.folderDescription,
        issues: this.folderSelectedIssues,
        parent_folder_id: this.folder.parent_folder_id
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Folder edited successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.loading = false;
        _this2.setTheState();
        _this2.$refs.editfoldermodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem editing your folder: ' + errorString,
          type: 'error',
          close: 'auto'
        });
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_requirementModal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_utils__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  data: function data() {
    return {};
  },

  props: {
    id: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_requirementModal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_utils__["a" /* default */]],
  mounted: function mounted() {
    this.getStatusesForCurrentProject();
    this.getRequirementAndSelectedDataFromRmcloud();
  },

  methods: {
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.submitting = true;
        this.submitData();
      }
    },
    shown: function shown() {
      this.getStatusesForCurrentProject();
      this.getRequirementAndSelectedDataFromRmcloud();
    },
    getRequirementAndSelectedDataFromRmcloud: function getRequirementAndSelectedDataFromRmcloud() {
      var _this = this;

      this.$http.get('/api/requirement/' + this.id).then(function (response) {
        _this.attachments = response.data.requirement.attachments;
        _this.requirement = response.data.requirement;
        _this.name = response.data.requirement.name;
        _this.displayID = response.data.requirement.display_id;
        _this.description = response.data.requirement.description;

        _this.getRequirements();
        _this.getAttributes();
        _this.getRequirementTypes();
        if (!_this.currentProjectIsGlobal) {
          _this.getAssignees();
          _this.getComponents(response.data.requirement.components);
        }

        _this.selectedRequirementType = _this.requirementTypes.find(function (r) {
          return r.requirement_type_id === response.data.requirement.requirement_type.requirement_type_id;
        });

        if (_this.$auth.user().installed_on_confluence) {
          _this.getContents(response.data.requirement.contents);
        }

        _this.selectedIssueIds = response.data.requirement.issues.map(function (d) {
          return d.atlassian_issue_id;
        });
        _this.getIssues();

        if (_this.requirement.status) {
          _this.selectedStatus = _this.statuses.find(function (s) {
            return s.id === _this.requirement.status.atlassian_status_id.toString();
          });
        } else {
          _this.selectedStatus = null;
        }
      }, function (response) {});
    },
    getAssignees: function getAssignees() {
      var _this2 = this;

      this.assigneesLoading = true;
      window.AP.request({
        url: '/rest/api/3/user/assignable/search?maxResults=1000&project=' + this.currentProject.key,
        success: function success(response) {
          response = JSON.parse(response);
          _this2.assignees = response;
          if (_this2.requirement.assigned_to) {
            _this2.selectedAssignee = _this2.assignees.find(function (s) {
              return s.accountId === _this2.requirement.assigned_to.account_id;
            });
          } else {
            _this2.selectedAssignee = null;
          }
          _this2.assigneesLoading = false;
        },
        error: function error() {
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem loading assignee data from Atlassian.  Please contact rmCloud support via the "Get help" button',
            type: 'error'
          });
        }
      });
    },
    getComponents: function getComponents(selectedComponents) {
      var _this3 = this;

      this.componentsLoading = true;
      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/components',
        success: function success(response) {
          response = JSON.parse(response);
          _this3.components = response;
          var selectedComponentIds = selectedComponents.map(function (c) {
            return c.atlassian_component_id;
          });
          _this3.selectedComponents = _this3.components.filter(function (c) {
            return selectedComponentIds.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(c.id));
          });
          _this3.componentsLoading = false;
        },
        error: function error() {
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem loading component data from Atlassian.  Please contact rmCloud support via the "Get help" button',
            type: 'error'
          });
        }
      });
    },
    getContents: function getContents(selectedContents) {
      var _this4 = this;

      this.contentsLoading = true;
      this.$http.get('api/confluence/content').then(function (response) {
        _this4.contents = response.data.results;
        var selectedContentIds = selectedContents.map(function (c) {
          return c.atlassian_content_id;
        });
        _this4.selectedContents = _this4.contents.filter(function (c) {
          return selectedContentIds.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(c.id));
        });
        _this4.contentsLoading = false;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading confluence data from Atlassian.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getRequirements: function getRequirements() {
      var _this5 = this;

      this.requirementsLoading = true;
      this.$http.get('/api/requirement?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this5.requirements = response.data.requirements.filter(function (r) {
          return r.requirement_id !== _this5.requirement.requirement_id;
        });

        var selectedRequirementIds = _this5.requirement.linked_requirements_v2.map(function (r) {
          return r.requirement_id;
        });
        _this5.selectedRequirements = _this5.requirements.filter(function (r) {
          return selectedRequirementIds.includes(r.requirement_id);
        });
        _this5.requirementsLoading = false;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading requirement data from rmCloud.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getRequirementTypes: function getRequirementTypes() {
      var _this6 = this;

      this.requirementTypesLoading = true;
      this.$http.get('/api/requirement/type').then(function (response) {
        _this6.requirementTypes = response.data.requirement_types;
        _this6.selectedRequirementType = _this6.requirementTypes.find(function (r) {
          return r.requirement_type_id === _this6.requirement.requirement_type.requirement_type_id;
        });
        _this6.requirementTypesLoading = false;
      }, function (response) {
        _this6.requirementTypesLoading = false;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading requirement type data from rmCloud.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshRequirementsDetail', true);
      this.$store.commit('setNeedToRefreshItemsList', true);
    },
    submitData: function submitData() {
      var _this7 = this;

      this.$ga.event('requirement', 'edit', this.name, 1);
      this.$http.put('/api/requirement/' + this.id, {
        assigned_to: this.selectedAssignee,
        attributes: this.requirement.attributes,
        attachments: this.attachments,
        name: this.name,
        components: this.selectedComponents,
        contents: this.selectedContents,
        description: this.description,
        display_id: this.displayID,
        issues: this.selectedIssues,
        linked_requirements: this.selectedRequirements,
        requirement_type_id: this.selectedRequirementType.requirement_type_id,
        status: this.selectedStatus
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Requirement edited successfully',
          type: 'success',
          close: 'auto'
        });
        _this7.submitting = false;
        _this7.setTheState();
        _this7.$refs.editreqmodal.hide();
      }, function (error) {
        var errorString = _this7.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem editing your requirement: ' + errorString,
          type: 'error',
          close: 'auto'
        });
        _this7.submitting = false;
      });
    }
  }
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_utils__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    }
  },
  data: function data() {
    return {
      error: '',
      format: 'csv',
      formatOptions: [{ value: 'csv', text: 'CSV' }],
      loading: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_utils__["a" /* default */]],
  methods: {
    clearModal: function clearModal() {
      this.error = '';
      this.format = 'csv';
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    handleOk: function handleOk(e) {
      e.preventDefault();
      this.loading = true;
      this.getRequirements();
    },
    generateCsv: function generateCsv(data) {
      var csv = __WEBPACK_IMPORTED_MODULE_0_papaparse___default.a.unparse(data);
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(blob, 'rmcloud-export-' + __WEBPACK_IMPORTED_MODULE_2_dayjs___default()().format() + '.csv');
      this.loading = false;
      this.$refs.exportrequirementsmodal.hide();
    },
    getRequirements: function getRequirements() {
      var _this = this;

      this.$http.get('/api/requirement/export?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        console.log('success');
        _this.generateCsv(response.data);
      }, function (error) {
        _this.loading = false;
        var errorString = _this.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem exporting your requirements: ' + errorString,
          type: 'error',
          close: 'auto'
        });
      });
    }
  }
});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_uploadToS3__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FoldersList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FoldersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FoldersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FoldersList: __WEBPACK_IMPORTED_MODULE_3__components_FoldersList___default.a },
  computed: {
    selectedFolder: function selectedFolder() {
      return this.$store.state.selectedFolder;
    }
  },
  data: function data() {
    return {
      assignBasedOnComponent: false,
      atlassianComponentJson: [],
      atlassianStatusesJson: [],
      folders: [],
      headers: [],
      loading: false,
      selectedHeaders: [],
      specificLocation: false,
      requirementType: null,
      requirementTypesLoading: false,
      requirementTypes: []
    };
  },

  props: {
    currentProject: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_uploadToS3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */]],
  methods: {
    clearModal: function clearModal() {
      this.assignBasedOnComponent = false;
      this.error = '';
      this.headers = [];
      this.loading = false;
      this.selectedHeaders = [];
      this.requirementType = null;
      this.specificLocation = false;
      this.uuidFileName = '';
      this.$refs.fileInput.value = null;
      this.$store.commit('setSelectedFolder', null);
      this.requirementTypesLoading = false;
      this.requirementTypes = [];
    },
    handleOk: function handleOk(e) {
      e.preventDefault();
      this.loading = true;
      this.importIssuesToRmcloudServer();
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    shown: function shown() {
      this.getRequirementTypes();
      this.getAtlassianComponentJson();
      this.getAtlassianStatusesJson();
      this.getPrimaryFolders();
    },
    getPrimaryFolders: function getPrimaryFolders() {
      var _this = this;

      this.$http.get('/api/folder/primary?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.folders = response.data.folders;
      }, function (response) {
        console.log('error');
      });
    },
    importIssuesToRmcloudServer: function importIssuesToRmcloudServer() {
      var _this2 = this;

      if (this.uuidFileName) {
        var importLocation = this.specificLocation ? this.selectedFolder.folder_id : null;
        this.$ga.event('requirement', 'import', importLocation, 1);
        this.$http.post('/api/import-issues', {
          assign_based_on_component: this.assignBasedOnComponent,
          atlassian_component_json: this.atlassianComponentJson,
          atlassian_statuses_json: this.atlassianStatusesJson,
          atlassian_project_id: this.currentProject.id,
          file_name: this.uuidFileName,
          location: importLocation,
          requirement_type: this.requirementType,
          additional_headers: this.selectedHeaders
        }).then(function (response) {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Requirements imported successfully',
            type: 'success',
            close: 'auto'
          });
          _this2.clearModal();
          _this2.setTheState();
          _this2.$refs.importissuesmodal.hide();
        }, function (error) {
          var errorString = _this2.createErrorStringFromResponse(error.response.data);
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem importing your requirements: ' + errorString,
            type: 'error'
          });
          _this2.loading = false;
        });
      }
    },
    getSignedRequest: function getSignedRequest(file) {
      var _this3 = this;

      var fileType = file.type;
      if (fileType.length === 0) {
        if (file.name && file.name.endsWith('.csv')) {
          fileType = 'text/csv';
        }
      }
      this.$http.post('/api/sign-s3-put', {
        operation: 'import',
        original_file_name: file.name,
        file_type: fileType
      }).then(function (response) {
        _this3.error = '';
        _this3.uploadFile(file, fileType, response.data.presigned_url, response.data.uuid_file_name);
      }, function (response) {
        _this3.error = 'Error getting signed url.  Did you upload a .csv?';
      });
    },
    getAtlassianComponentJson: function getAtlassianComponentJson() {
      var _this4 = this,
          _arguments = arguments;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/components',
        success: function success(response) {
          response = JSON.parse(response);

          _this4.atlassianComponentJson = response;
        },
        error: function error() {
          console.log(_arguments);
        }
      });
    },
    getAtlassianStatusesJson: function getAtlassianStatusesJson() {
      var _this5 = this,
          _arguments2 = arguments;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/statuses',
        success: function success(response) {
          response = JSON.parse(response);

          _this5.atlassianStatusesJson = response;
        },
        error: function error() {
          console.log(_arguments2);
        }
      });
    },
    getRequirementTypes: function getRequirementTypes() {
      var _this6 = this;

      this.requirementTypesLoading = true;
      this.$http.get('/api/requirement/type').then(function (response) {
        _this6.requirementTypes = response.data.requirement_types;
        _this6.requirementTypesLoading = false;
      }, function (response) {
        _this6.requirementTypesLoading = false;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading requirement type data from rmCloud.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    processFile: function processFile(event) {
      var _this7 = this;

      var file = event.target.files[0];
      __WEBPACK_IMPORTED_MODULE_2_papaparse___default.a.parse(file, {
        header: true,
        complete: function complete(results) {
          var excludeHeaders = ['Summary', 'Description', 'Issue key', 'Component/s', 'Status', 'Name', 'ID'];
          _this7.headers = results.meta.fields.map(function (h, index) {
            return { index: index, name: h };
          }).filter(function (h) {
            return !excludeHeaders.includes(h.name);
          });
        }
      });
      if (!file) {
        return alert('No file selected.');
      }
      this.getSignedRequest(file);
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
    }
  }
});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FoldersList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FoldersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FoldersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FoldersList: __WEBPACK_IMPORTED_MODULE_0__components_FoldersList___default.a },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    selectedFolder: function selectedFolder() {
      return this.$store.state.selectedFolder;
    }
  },
  data: function data() {
    return {
      folders: [],
      loading: false
    };
  },

  props: {
    folder: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */]],
  methods: {
    clearModal: function clearModal() {
      this.loading = false;
      this.$store.commit('setSelectedFolder', null);
    },
    getPrimaryFolders: function getPrimaryFolders() {
      var _this = this;

      this.$http.get('/api/folder/primary?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.folders = response.data.folders;
      }, function (response) {
        console.log('error');
      });
    },
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.loading = true;
        this.submitData();
      }
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    shown: function shown() {
      this.getPrimaryFolders();
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
      this.$store.commit('setNeedToRefreshRequirementsDetail', true);
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('folder', 'move', this.folder.folder_id, 1);
      var folderToSubmit = this.folder;
      folderToSubmit.parent_folder_id = this.selectedFolder.folder_id;
      this.$http.put('/api/folder/' + this.folder.folder_id, folderToSubmit).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: 'Folder moved successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.clearModal();
        _this2.setTheState();
        _this2.$refs.movefoldermodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem moving your folder: ' + errorString,
          type: 'error',
          close: 'auto'
        });
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FoldersList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FoldersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FoldersList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_utils__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { FoldersList: __WEBPACK_IMPORTED_MODULE_0__components_FoldersList___default.a },
  computed: {
    currentProject: function currentProject() {
      return this.$store.state.currentProject;
    },
    selectedFolder: function selectedFolder() {
      return this.$store.state.selectedFolder;
    }
  },
  data: function data() {
    return {
      folders: [],
      loading: false
    };
  },

  props: {
    modalId: String,
    requirements: Array
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_utils__["a" /* default */]],
  methods: {
    clearModal: function clearModal() {
      this.loading = false;
      this.$store.commit('setSelectedFolder', null);
    },
    getPrimaryFolders: function getPrimaryFolders() {
      var _this = this;

      this.$http.get('/api/folder/primary?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this.folders = response.data.folders;
      }, function (response) {
        console.log('error');
      });
    },
    handleOk: function handleOk(e) {
      e.preventDefault();

      this.$validator.validateAll().then(function () {}).catch(function () {});
      if (this.errors.any()) {
        return e.cancel();
      } else {
        this.loading = true;
        this.submitData();
      }
    },
    handleCancel: function handleCancel(e) {
      this.clearModal();
    },
    shown: function shown() {
      this.getPrimaryFolders();
    },
    setTheState: function setTheState() {
      this.$store.commit('setNeedToRefreshItemsList', true);
      this.$store.commit('setNeedToRefreshRequirementsDetail', true);
      this.$store.commit('clearSelectedRequirements');
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$ga.event('requirement', 'move', this.requirements.length > 1 ? 'bulk' : 'single', 1);
      this.$http.post('/api/requirement/move/bulk', {
        parent_folder_id: this.selectedFolder.folder_id,
        requirements: this.requirements
      }).then(function (response) {
        window.AP.flag.create({
          title: 'Success!',
          body: _this2.requirements.length === 1 ? 'Requirement moved successfully' : 'Requirements moved successfully',
          type: 'success',
          close: 'auto'
        });
        _this2.clearModal();
        _this2.setTheState();
        _this2.$refs.moverequirementmodal.hide();
      }, function (error) {
        var errorString = _this2.createErrorStringFromResponse(error.response.data);
        var requirementWord = _this2.requirements.length === 1 ? 'requirement' : 'requirements';
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem moving your ' + requirementWord + ': ' + errorString,
          type: 'error',
          close: 'auto'
        });
        _this2.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PreviewImageModal',
  props: {
    modalImageFilename: String,
    modalImageUrl: String
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_utils__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      baseUrl: null,
      issueId: this.$route.query.issueId,
      projectId: this.$route.query.projectId,
      requirements: []
    };
  },
  created: function created() {
    this.getBaseUrl();
    this.getLinkedRequirements();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_utils__["a" /* default */]],
  methods: {
    getLinkedRequirements: function getLinkedRequirements() {
      var _this = this;

      this.$http.get('/api/requirement?atlassian_project_id=' + this.projectId + '&atlassian_project_id=0&atlassian_issue_id=' + this.issueId).then(function (response) {
        _this.requirements = response.data.requirements;
      }, function (response) {
        console.log('error');
      });
    },
    getBaseUrl: function getBaseUrl() {
      var _this2 = this;

      window.AP.getLocation(function (location) {
        var url = new URL(location);
        _this2.baseUrl = url.origin;
      });
    },
    getNewTabLink: function getNewTabLink(requirement) {
      return this.baseUrl + '/plugins/servlet/ac/' + "rmcloud" + '/rmcloud?ac.projectId=' + this.projectId + '&ac.requirementId=' + requirement.requirement_id;
    },
    openLinkRequirementsDialog: function openLinkRequirementsDialog() {
      window.AP.dialog.create({
        key: 'link-requirements-dialog',
        width: '80%',
        height: '60%',
        chrome: true,
        header: 'Update linked requirements',
        customData: {
          issueId: this.issueId,
          projectId: this.projectId
        }
      }).on('close', this.getLinkedRequirements);
    }
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a }
});

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 851:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    createErrorStringFromResponse: function createErrorStringFromResponse(responseData) {
      var errorString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (responseData.hasOwnProperty('Result')) {
        return responseData['Result'];
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(responseData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var errorField = _step.value;

            errorString += errorField[0] + ' - ';
            if (Array.isArray(errorField[1])) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(errorField[1]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var individualError = _step2.value;

                  errorString += individualError + ' ';
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else if (errorField[1].hasOwnProperty('0')) {
              errorString = this.createErrorStringFromResponse(errorField[1]['0'], errorString);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return errorString;
    },
    backupResizeToParentInCaseAuthViewOneFails: function backupResizeToParentInCaseAuthViewOneFails() {
      var resize = function resize() {
        window.AP.sizeToParent();
      };
      setTimeout(resize, 1000);
    }
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(90);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getIssueDataFromAtlassianPaginated: function getIssueDataFromAtlassianPaginated(issueArray) {
      var _this = this;

      var nextPageToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var maxResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

      var payload = {
        jql: 'id in (' + issueArray.join(',') + ')',
        fields: ['issuetype', 'summary', 'status'],
        fieldsByKeys: false,
        maxResults: maxResults
      };

      if (nextPageToken) {
        payload.nextPageToken = nextPageToken;
      }

      window.AP.request({
        url: '/rest/api/3/search/jql',
        type: 'POST',
        contentType: 'application/json',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        success: function success(response) {
          response = JSON.parse(response);
          var donePaginating = !response.nextPageToken;
          _this.setIssues(response, donePaginating);
          if (!donePaginating) {
            _this.getIssueDataFromAtlassianPaginated(issueArray, response.nextPageToken, maxResults);
          }
        },
        error: function error(response) {
          __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    },
    getComponents: function getComponents() {
      var _this2 = this;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/components',
        success: function success(response) {
          response = JSON.parse(response);
          _this2.components = response;
        },
        error: function error(response) {
          __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    },
    getStatusesForCurrentProject: function getStatusesForCurrentProject() {
      var _this3 = this;

      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/statuses',
        success: function success(response) {
          response = JSON.parse(response);
          _this3.setStatusOptions(response);
        },
        error: function error(response) {
          __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    },
    getAllStatuses: function getAllStatuses() {
      var _this4 = this;

      window.AP.request({
        url: '/rest/api/3/status',
        success: function success(response) {
          response = JSON.parse(response);
          _this4.setStatusOptions(response);
        },
        error: function error(response) {
          __WEBPACK_IMPORTED_MODULE_1__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    }
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_getDataFromAtlassian__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_browser__ = __webpack_require__(90);







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_getDataFromAtlassian__["a" /* default */]],
  computed: {
    availableRequirements: function availableRequirements() {
      if (this.selectedRequirementType && this.selectedRequirementType.level) {
        var allowedTypeIds = [this.selectedRequirementType.level + 1, this.selectedRequirementType.level - 1];
        return this.requirements.filter(function (requirement) {
          return allowedTypeIds.includes(requirement.level);
        });
      } else {
        return [];
      }
    },
    sortedIssues: function sortedIssues() {
      return this.issues.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    loading: function loading() {
      return this.issuesLoading || this.contentsLoading || this.statusesLoading || this.requirementsLoading || this.componentsLoading || this.assigneesLoading || this.attributesLoading;
    },
    nameState: function nameState() {
      return this.name.length > 0;
    },
    nameInvalidFeedback: function nameInvalidFeedback() {
      if (this.name.length === 0) {
        return 'Required';
      }
      return '';
    },
    requirementTypeInvalidFeedback: function requirementTypeInvalidFeedback() {
      if (!this.selectedRequirementType) {
        return 'Required';
      }
      return '';
    },
    requirementTypeState: function requirementTypeState() {
      return this.selectedRequirementType !== null;
    },
    shouldDisableIssuesMultiselect: function shouldDisableIssuesMultiselect() {
      return this.sortedIssues.length === 0 && !this.issuesLoading;
    },
    currentProjectIsGlobal: function currentProjectIsGlobal() {
      return this.currentProject && this.currentProject.id === 0;
    }
  },
  data: function data() {
    return {
      assignees: [],
      assigneesLoading: false,
      attributes: {},
      attributesLoading: false,
      attachments: [],
      components: [],
      contents: [],
      contentsLoading: false,
      componentsLoading: false,
      description: '',
      displayID: null,
      issues: [],
      issuesLoading: false,
      id: null,
      name: '',
      requirements: [],
      requirementsLoading: false,
      requirementTypes: [],
      requirementTypesLoading: false,
      selectedAssignee: null,
      selectedAttributes: {},
      selectedComponents: [],
      selectedContents: [],
      selectedIssueIds: [],
      selectedIssues: [],
      selectedRequirements: [],
      selectedRequirementType: null,
      selectedStatus: null,
      statuses: [],
      statusesLoading: false,
      submitting: false
    };
  },

  methods: {
    customIssueLabel: function customIssueLabel(_ref) {
      var key = _ref.key,
          fields = _ref.fields;

      return key + ': ' + fields.summary;
    },
    customRequirementLabel: function customRequirementLabel(requirement) {
      var idToShow = requirement.display_id ? requirement.display_id : requirement.requirement_id;
      return '' + requirement.prefix + idToShow + ': ' + requirement.name;
    },
    getAssignees: function getAssignees() {
      var _this = this;

      this.assigneesLoading = true;
      window.AP.request({
        url: '/rest/api/3/user/assignable/search?maxResults=1000&project=' + this.currentProject.key,
        success: function success(response) {
          _this.assignees = JSON.parse(response);
          _this.assigneesLoading = false;
        },
        error: function error(response) {
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem loading assignee data from Atlassian.  Please contact rmCloud support via the "Get help" button',
            type: 'error'
          });
          __WEBPACK_IMPORTED_MODULE_6__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    },
    getAttributes: function getAttributes() {
      var _this2 = this;

      this.attributesLoading = true;
      this.$http.get('api/attribute?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this2.attributes = response.data.attributes;
        _this2.attributesLoading = false;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading custom attributes.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getOptionsArray: function getOptionsArray(options) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          result.push({
            value: option.attribute_option_id, text: option.name
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    getComponents: function getComponents() {
      var _this3 = this;

      this.componentsLoading = true;
      window.AP.request({
        url: '/rest/api/3/project/' + this.currentProject.id + '/components',
        success: function success(response) {
          _this3.components = JSON.parse(response);
          _this3.componentsLoading = false;
        },
        error: function error(response) {
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem loading component data from Atlassian.  Please contact rmCloud support via the "Get help" button',
            type: 'error'
          });
          __WEBPACK_IMPORTED_MODULE_6__sentry_browser__["c" /* captureMessage */](response);
        }
      });
    },
    getContents: function getContents() {
      var _this4 = this;

      this.contentsLoading = true;
      this.$http.get('api/confluence/content').then(function (response) {
        _this4.contents = response.data.results;
        _this4.contentsLoading = false;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading confluence data from Atlassian.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getRequirements: function getRequirements() {
      var _this5 = this;

      this.requirementsLoading = true;
      this.$http.get('/api/requirement?atlassian_project_id=' + this.currentProject.id).then(function (response) {
        _this5.requirements = response.data.requirements;
        _this5.requirementsLoading = false;
      }, function (response) {
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading requirement data from rmCloud.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getRequirementTypes: function getRequirementTypes() {
      var _this6 = this;

      this.requirementTypesLoading = true;
      this.$http.get('/api/requirement/type').then(function (response) {
        _this6.requirementTypes = response.data.requirement_types;
        _this6.requirementTypesLoading = false;
      }, function (response) {
        _this6.requirementTypesLoading = false;
        window.AP.flag.create({
          title: 'Error',
          body: 'There was a problem loading requirement type data from rmCloud.  Please contact rmCloud support via the "Get help" button',
          type: 'error'
        });
      });
    },
    getRequirementsPlaceholder: function getRequirementsPlaceholder() {
      if (this.selectedRequirementType) {
        return 'Associate with requirement(s)';
      } else {
        return 'Please select a requirement type above.';
      }
    },
    getIssues: function getIssues() {
      var _this7 = this;

      this.issues = [];
      this.issuesLoading = true;

      var maxResults = 100;
      var payload = {
        'fields': ['summary'],
        'fieldsByKeys': false,
        'maxResults': maxResults
      };
      if (!this.currentProjectIsGlobal) {
        payload['jql'] = 'project = "' + this.currentProject.key + '"';
      }

      var makeIssueRequest = function makeIssueRequest() {
        var nextPageToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (nextPageToken) {
          payload['nextPageToken'] = nextPageToken;
        } else {
          delete payload['nextPageToken'];
        }
        window.AP.request({
          url: '/rest/api/3/search/jql',
          type: 'POST',
          contentType: 'application/json',
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload),
          success: function success(response) {
            var issueResponse = JSON.parse(response);
            if (issueResponse.issues) {
              _this7.issues.push.apply(_this7.issues, issueResponse.issues);
            }

            if (issueResponse.nextPageToken) {
              makeIssueRequest(issueResponse.nextPageToken);
            } else {
              _this7.selectedIssues = _this7.issues.filter(function (issue) {
                return _this7.selectedIssueIds.includes(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(issue.id));
              });
              _this7.issuesLoading = false;
            }
          },
          error: function error(response) {
            _this7.$ga.event('error', 'getIssues', 'api-error', 1);
            __WEBPACK_IMPORTED_MODULE_6__sentry_browser__["c" /* captureMessage */](response);
            window.AP.flag.create({
              title: 'Error',
              body: 'There was a problem loading issue data from Atlassian.  Please contact rmCloud support via the "Get help" button',
              type: 'error'
            });
            _this7.issuesLoading = false;
          }
        });
      };

      makeIssueRequest(null);
    },
    setStatusOptions: function setStatusOptions(response) {
      var _ref2;

      var fullList = (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(response.map(function (issueType) {
        return issueType.statuses;
      })));

      var uniqueStatusSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      this.statuses = fullList.filter(function (status) {
        if (uniqueStatusSet.has(status.id)) {
          return false;
        }
        uniqueStatusSet.add(status.id);
        return true;
      });
    }
  }
});

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(852)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(875)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(853)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(844)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(846)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(874)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(877)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(848)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(850)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(840)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-071b192f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-734da580",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(855)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-442ab0cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(854)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-38cde03a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(847)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-24978bad",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-97d8de4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(851)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  "data-v-2f96344d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-77f9b1aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(845)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(872)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  "data-v-d9eaf6f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 990:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "createfoldermodal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.currentTitle,
      "name": "create-folder-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Create",
      "ok-disabled": !_vm.folderName || _vm.errors.has('name'),
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleOk($event)
      }
    }
  }, [_c('form', {
    attrs: {
      "id": "create-folder-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 100,
        regex: /^[^\\]+$/
      }),
      expression: "{ required: true, max: 100, regex: /^[^\\\\]+$/ }"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Folder name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), (_vm.currentProject && !_vm.parentFolderId) ? _c('span', [_vm._v("This will be added to the root of project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])]) : _vm._e(), _vm._v(" "), (_vm.currentProject && _vm.parentFolderId) ? _c('span', [_vm._v("This will be added to the project "), _c('strong', [_vm._v(_vm._s(_vm.currentProject.name))])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Creating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.maintenanceMode) ? _c('div', [_vm._v("rmCloud is currently under maintenance.  Please check back soon!")]) : _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 992:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "deletebaselinemodal",
    attrs: {
      "id": "delete-baseline-modal",
      "title": "Are you sure you want to delete this baseline?",
      "name": "delete-baseline-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Delete",
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    }
  }, [_vm._v("\n  This action can not be undone\n  "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Deleting\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 993:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Oops!")]), _vm._v(" "), _c('p', [_vm._v("\n      There was a problem with your rmCloud license.  Please try installing the add-on again or asking your adminstrator.\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 994:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "deletefoldermodal",
    attrs: {
      "id": "delete-folder-modal",
      "title": "Are you sure you want to delete this folder?",
      "name": "delete-folder-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Delete",
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    }
  }, [_vm._v("\n  This will also delete all folders and requirements inside this folder\n  "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Deleting\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-nav', {
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'requirements'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('requirements')
      }
    }
  }, [_vm._v("Requirements")]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'traceability'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('traceability')
      }
    }
  }, [_vm._v("Traceability Matrix")]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'baselines'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('baselines')
      }
    }
  }, [_vm._v("Baselines")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "project-selection"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.projectsArray
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  })], 1), _vm._v(" "), (_vm.currentProjectIsGlobal) ? _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Global Requirements is a special project automatically created for you that allows you to link to issues across your whole Jira instance (not just within a single project)"
    }
  }, [_c('icon', {
    attrs: {
      "id": "global-icon",
      "name": "info-circle"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items-list",
    class: {
      inner: _vm.isInnerList
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', [_c('a', {
      staticClass: "card-link",
      attrs: {
        "title": item.name
      },
      on: {
        "click": function($event) {
          _vm.setCurrentItem(item, $event)
        }
      }
    }, [_c('b-card', {
      staticClass: "individual-item",
      attrs: {
        "no-body": "",
        "bg-variant": _vm.isCurrentItem(item) ? 'light' : '',
        "border-variant": _vm.isCurrentItem(item) ? 'primary' : 'light'
      }
    }, [_c('p', {
      staticClass: "card-text"
    }, [(item.type.endsWith('requirement')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRequirements),
        expression: "selectedRequirements"
      }],
      staticClass: "prevent-this-click",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.selectedRequirements) ? _vm._i(_vm.selectedRequirements, item) > -1 : (_vm.selectedRequirements)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedRequirements,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRequirements = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedRequirements = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRequirements = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('icon', {
      class: _vm.getIconClass(item),
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": item.type === 'requirement' ? 'file-text-o' : 'folder-o'
      }
    }), _vm._v(" "), (item.type === 'requirement') ? _c('span', {
      staticClass: "my-card-text listview-item-id"
    }, [_vm._v(_vm._s(item.prefix + _vm.getID(item)))]) : _c('span', {
      staticClass: "my-card-text listview-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.has_descendant_folders || item.has_descendant_requirements) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.toggle(item)
        }
      }
    }, [_c('icon', {
      staticClass: "prevent-this-click",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": _vm.isExpandedFolder(item) ? 'minus-square-o' : 'plus-square-o'
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'requirement') ? _c('span', [_c('br'), _vm._v(" "), _c('span', {
      staticClass: "my-card-text listview-item-name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()], 1)])], 1), _vm._v(" "), (item.descendants) ? _c('items-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openFolderIds && _vm.openFolderIds.hasOwnProperty(item.folder_id)),
        expression: "openFolderIds && openFolderIds.hasOwnProperty(item.folder_id)"
      }],
      attrs: {
        "items": item.descendants,
        "selectedRequirements": _vm.selectedRequirements,
        "isInnerList": "true"
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.baseline) ? _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.baseline.name))])]), _vm._v(" "), _c('delete-baseline-modal', {
    attrs: {
      "baseline": _vm.baseline,
      "modalId": "delete-baseline-modal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-view-buttons"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-baseline-modal",
      modifiers: {
        "delete-baseline-modal": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n        Delete\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_c('table', {
    staticClass: "table table-sm baseline-detail-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("ID:")]), _vm._v(" "), _c('td', [_vm._v("B" + _vm._s(_vm.baseline.baseline_id))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Created:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getHumanDate(_vm.baseline.created_at + 'Z')))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Reporter:")]), _vm._v(" "), (_vm.reporter) ? _c('td', [_vm._v(_vm._s(_vm.reporter.displayName))]) : _c('td', {
    staticClass: "help-text"
  }, [_vm._v("None")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.baseline.description) ? _c('b-form-textarea', {
    attrs: {
      "plaintext": "",
      "no-resize": "",
      "max-rows": 6,
      "value": _vm.baseline.description
    }
  }) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("No description")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Requirements")]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [(_vm.baseline.requirement_revisions.length > 0) ? _c('table', {
    staticClass: "table table-sm baseline-detail-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.baseline.requirement_revisions), function(requirement_revision) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(requirement_revision.prefix) + _vm._s(requirement_revision.display_id ? requirement_revision.display_id : requirement_revision.requirement_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(requirement_revision.name))])])
  }))]) : _c('span', {
    staticClass: "help-text"
  }, [_vm._v("No requirements in baseline")])])])])], 1) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")])])])
}]}

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "editfoldermodal",
    attrs: {
      "id": "edit-folder-modal",
      "name": "edit-folder-modal",
      "title": "Edit folder",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Update",
      "ok-disabled": !_vm.folderName,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "update-folder-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Folder name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Updating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

},[411]);


// WEBPACK FOOTER //
// static/js/app.db1b8c9d4dc30f935bb4.js